"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[674],{

/***/ 4789:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(1720));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const f = () => ({
    __html: `<svg width="16" height="10" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.50008 7.02066L14.6876 0.833164L16.4551 2.60066L8.50008 10.5557L0.545079 2.60066L2.31258 0.833164L8.50008 7.02066Z" fill="#707F8C"/>
  </svg>`,
});
const StyledSpan = building_blocks_ui_common_1.styled.span `
  ${(props) => props.styles}
`;
const Img = ({ styles }) => {
    return React.createElement(StyledSpan, { styles: styles, dangerouslySetInnerHTML: f() });
};
exports["default"] = Img;
//# sourceMappingURL=dropdownIcon.js.map

/***/ }),

/***/ 499:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(1720));
const Back = () => {
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M13.9602 18.2312L6.9257 12.1463L13.5026 5.5694", stroke: "#36354C", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
exports["default"] = Back;
//# sourceMappingURL=Back.js.map

/***/ }),

/***/ 7101:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(1720));
const Close = () => {
    return (react_1.default.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M9.31333 1.39325C9.50847 1.19811 9.50847 0.881726 9.31333 0.686585C9.11819 0.491445 8.8018 0.491445 8.60666 0.686585L5 4.29325L1.39333 0.686586C1.19819 0.491445 0.881802 0.491445 0.686662 0.686585C0.491521 0.881726 0.491521 1.19811 0.686662 1.39325L4.29333 4.99992L0.686662 8.60658C0.491521 8.80173 0.491521 9.11811 0.686662 9.31325C0.881802 9.50839 1.19819 9.50839 1.39333 9.31325L5 5.70659L8.60666 9.31325C8.8018 9.50839 9.11819 9.50839 9.31333 9.31325C9.50847 9.11811 9.50847 8.80173 9.31333 8.60659L5.70666 4.99992L9.31333 1.39325Z", fill: "#36354C" })));
};
exports["default"] = Close;
//# sourceMappingURL=Close.js.map

/***/ }),

/***/ 5061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const search_bar_styles_1 = __webpack_require__(9454);
const react_1 = __importDefault(__webpack_require__(1720));
const SearchIcon = () => {
    return (react_1.default.createElement(search_bar_styles_1.SearchIconContainer, null,
        ' ',
        react_1.default.createElement("svg", { width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M7.46785 14.9357C3.34088 14.9357 0 11.5948 0 7.46785C0 3.34088 3.34088 0 7.46785 0C11.5948 0 14.9357 3.34088 14.9357 7.46785C14.9357 11.5948 11.5948 14.9357 7.46785 14.9357ZM7.46785 1.47392C4.12697 1.47392 1.47392 4.12697 1.47392 7.46785C1.47392 10.8087 4.12697 13.4618 7.46785 13.4618C10.8087 13.4618 13.4618 10.8087 13.4618 7.46785C13.4618 4.12697 10.7105 1.47392 7.46785 1.47392Z", fill: "#36354C" }),
            react_1.default.createElement("path", { d: "M16.0181 16.9997C15.7233 16.9997 15.5268 16.9014 15.3302 16.7049L11.7928 13.1675C11.3998 12.7745 11.3998 12.1849 11.7928 11.7919C12.1859 11.3988 12.7754 11.3988 13.1685 11.7919L16.7059 15.3293C17.0989 15.7223 17.0989 16.3119 16.7059 16.7049C16.5094 16.9014 16.3128 16.9997 16.0181 16.9997Z", fill: "#36354C" }))));
};
exports["default"] = SearchIcon;
//# sourceMappingURL=Search.js.map

/***/ }),

/***/ 3296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommonDropdown = CommonDropdown;
const react_1 = __importStar(__webpack_require__(1720));
const common_dropdown_styles_1 = __webpack_require__(8754);
const dropdownIcon_1 = __importDefault(__webpack_require__(4789));
function CommonDropdown(props) {
    const { selectedOption, dropdownOptions, handleClick, placeholderValue } = props;
    const [selectedHelpOption, setSelectedHelpOption] = (0, react_1.useState)(selectedOption || placeholderValue);
    const [showDropdown, setShowDropdown] = (0, react_1.useState)(false);
    // Open/Close dropdown with a list of options using ref
    const dropElement = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (typeof document === "undefined")
            return;
        function onClickOutside(event) {
            if ((dropElement === null || dropElement === void 0 ? void 0 : dropElement.current) !== null) {
                let isClickInside = dropElement === null || dropElement === void 0 ? void 0 : dropElement.current.contains(event.target);
                if (!isClickInside) {
                    setShowDropdown(false);
                }
            }
        }
        document.addEventListener("click", onClickOutside);
        return () => {
            document.removeEventListener("click", onClickOutside);
        };
    }, []);
    const onSelectChange = (itemId) => {
        const selectedRawValue = dropdownOptions.find((value) => value.id === itemId);
        if (selectedRawValue)
            handleClick(selectedRawValue);
    };
    return (react_1.default.createElement(common_dropdown_styles_1.DropDownContainer, { showDrop: showDropdown, inputWidth: props.inputWidth, ref: dropElement },
        react_1.default.createElement(common_dropdown_styles_1.CustomSelect, { value: selectedHelpOption, placeholder: placeholderValue, autoComplete: "off", readOnly: true, spellCheck: "false", onClick: () => {
                setShowDropdown(!showDropdown);
            } }),
        react_1.default.createElement(common_dropdown_styles_1.DropPosition, { showDrop: showDropdown, onClick: () => {
                setShowDropdown(!showDropdown);
            } },
            react_1.default.createElement(dropdownIcon_1.default, null)),
        showDropdown && (react_1.default.createElement(common_dropdown_styles_1.DropBox, null, dropdownOptions.map((item) => {
            return (react_1.default.createElement(common_dropdown_styles_1.DropItemWrapper, { key: item.id },
                react_1.default.createElement(common_dropdown_styles_1.HelpItem, { onClick: () => {
                        setSelectedHelpOption(item.title);
                        onSelectChange(item.id);
                        setShowDropdown(false);
                    } },
                    react_1.default.createElement(common_dropdown_styles_1.HelpText, null, item.title))));
        })))));
}
//# sourceMappingURL=common-dropdown.js.map

/***/ }),

/***/ 8754:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HelpText = exports.HelpItem = exports.DropItemWrapper = exports.DropBox = exports.DropPosition = exports.CustomSelect = exports.DropDownContainer = void 0;
const building_blocks_ui_common_1 = __webpack_require__(9749);
const building_blocks_ui_typography_1 = __webpack_require__(9829);
// const dropDownIcon = require("./assets/dropdownIcon.svg");
exports.DropDownContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  position: relative;
  width: ${(props) => (props.inputWidth ? props.inputWidth : "")};
  @media (max-width: 768px) {
    height: ${(props) => (props.showDrop ? "165px" : "")};
  }

  @media (max-width: 480px) {
    height: ${(props) => (props.showDrop ? "165px" : "")};
  }
`;
/* height set to 100vw */
exports.CustomSelect = building_blocks_ui_common_1.styled.input `
  width: 100%;
  height: 58px;
  outline: 0;
  box-shadow: none;
  border: 1px solid #c8d0db;
  box-sizing: border-box;
  border-radius: 10px;
  background: white;
  color: #707f8c;
  padding: 0px 15px;
  font-size: 1rem;
  -webkit-appearance: none;
  text-overflow: ellipsis;

  &:focus {
    border: 0.5px solid #7c47e1;
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 0.875rem;
  }

  @media (max-width: 480px) {
    width: 100%;
    font-size: 0.875rem;
  }

  @media (max-width: 300px) {
    width: 100%;
    font-size: 0.875rem;
  }
`;
exports.DropPosition = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Box) `
  position: absolute;
  right: 10px;
  top: 32%;
  width: unset;
  cursor: pointer;
  @media (max-width: 768px) {
    top: ${(props) => (props.showDrop ? "11%" : "32%")};
  }
`;
exports.DropBox = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  box-shadow: rgba(8, 12, 41, 0.1) 0px 4px 35px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  z-index: 10;
  width: 100%;
  overflow-y: scroll;
  background: #fcfcfc;
  border-radius: 12px;
  flex-direction: column;
  overflow-x: hidden;
`;
exports.DropItemWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  margin-top: 6px;
  border-bottom: 1px solid rgb(244, 245, 247);
  padding: 10px 20px;
  width: inherit !important;
  box-sizing: border-box;
`;
exports.HelpItem = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  padding: 10px 0;
  cursor: pointer;
  box-sizing: border-box;
  width: inherit;
`;
exports.HelpText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-weight: ${building_blocks_ui_common_1.$fontWeightLight};
  font-size: 1rem;
  line-height: ${building_blocks_ui_common_1.$fontSize.normal};
  color: #434f5a;
  width: inherit;

  ${exports.DropItemWrapper}:hover & {
    color: #282e33;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    font-size: ${building_blocks_ui_common_1.$fontSize.xs};
  }

  @media (max-width: 480px) {
    font-size: ${building_blocks_ui_common_1.$fontSize.xs};
  }
`;
//# sourceMappingURL=common-dropdown.styles.js.map

/***/ }),

/***/ 7648:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dropdown = Dropdown;
const react_1 = __importStar(__webpack_require__(1720));
const building_blocks_ui_theme_1 = __webpack_require__(549);
const search_bar_1 = __importDefault(__webpack_require__(6476));
const Styles = __importStar(__webpack_require__(780));
function Dropdown(props) {
    const { id, className, show, value, label, options, error, heading, hideClose, hideHeader, hideList, children, toggleDropdown, onChange, showLabelAfterSelect, showSearchBar, } = props;
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const dropdownRef = (0, react_1.useRef)(null);
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(value || null);
    const [showDropdown, setShowDropdown] = (0, react_1.useState)(show || false);
    const [searchInput, setSearchInput] = (0, react_1.useState)('');
    const [showSearch, setShowSearch] = (0, react_1.useState)(false);
    const [dropdownOptions, setDropdownOptions] = (0, react_1.useState)(options);
    (0, react_1.useEffect)(() => {
        if (typeof document === 'undefined')
            return;
        function onClickOutside(event) {
            if ((dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) !== null) {
                const isClickInside = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current.contains(event.target);
                if (!isClickInside) {
                    toggleDropdown ? toggleDropdown(false) : setShowDropdown(false);
                }
            }
        }
        document.addEventListener('click', onClickOutside);
        return () => {
            document.body.style.overflowY = 'auto';
            document.removeEventListener('click', onClickOutside);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        setShowDropdown(show);
        if (show) {
            document.body.style.overflowY = 'hidden';
        }
        else {
            document.body.style.overflowY = 'auto';
        }
    }, [show]);
    (0, react_1.useEffect)(() => {
        setSelectedOption(value);
    }, [value]);
    (0, react_1.useEffect)(() => {
        const searchTerm = searchInput === null || searchInput === void 0 ? void 0 : searchInput.trim();
        if (searchInput !== '') {
            const updatedList = options === null || options === void 0 ? void 0 : options.filter((optionItem) => {
                return optionItem === null || optionItem === void 0 ? void 0 : optionItem.displayValue.toLowerCase().match(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase());
            });
            setDropdownOptions(updatedList);
        }
        else
            setDropdownOptions(options);
    }, [searchInput]);
    (0, react_1.useEffect)(() => {
        setDropdownOptions(options);
    }, [options]);
    const handleDropdownClick = (e) => {
        if (e.target.id === 'dropdown') {
            toggleDropdown
                ? toggleDropdown(!showDropdown)
                : setShowDropdown(!showDropdown);
        }
        else if (e.target.id === 'bottomSheet') {
            toggleDropdown ? toggleDropdown(false) : setShowDropdown(false);
        }
    };
    const handleSelect = (option) => {
        setSelectedOption(option);
        onChange(option);
        toggleDropdown ? toggleDropdown(false) : setShowDropdown(false);
    };
    const onClickClose = () => {
        setShowDropdown(false);
        toggleDropdown === null || toggleDropdown === void 0 ? void 0 : toggleDropdown(false);
    };
    return (react_1.default.createElement(Styles.Wrapper, { id: id || 'dropdown', className: className, selected: Boolean(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value), error: Boolean(error), label: label, theme: theme, colors: colors, ref: dropdownRef, onClick: handleDropdownClick, showLabelAfterSelect: showLabelAfterSelect },
        (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.displayValue) && (react_1.default.createElement(Styles.SelectedOption, { colors: colors, theme: theme }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.displayValue)),
        showDropdown && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Styles.DropdownListWrapper, { id: "bottomSheet", colors: colors, theme: theme },
                react_1.default.createElement(Styles.DropdownList, { colors: colors, theme: theme, closing: true, hideHeader: hideHeader, showLabelAfterSelect: showLabelAfterSelect },
                    !hideHeader && (react_1.default.createElement(Styles.BottomSheetHeader, { hideClose: hideClose, colors: colors, theme: theme },
                        heading || ``,
                        react_1.default.createElement("span", { onClick: onClickClose }))),
                    showSearchBar && (react_1.default.createElement(Styles.SearchContainer, null,
                        react_1.default.createElement(search_bar_1.default, { placeholder: 'Search', onChange: (val) => setSearchInput(val), onFocus: () => setShowSearch(true), onBack: () => {
                                setShowSearch(false);
                                setSearchInput('');
                            }, inFocus: showSearch, theme: theme, colors: colors }))),
                    children,
                    !hideList && (react_1.default.createElement(Styles.DropdownScrollList, null, dropdownOptions === null || dropdownOptions === void 0 ? void 0 :
                        dropdownOptions.map((option, id) => (react_1.default.createElement(Styles.ListItem, { key: id, colors: colors, theme: theme, selected: option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value), onClick: () => handleSelect(option) }, option.displayValue))),
                        (dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.length) === 0 && (react_1.default.createElement(Styles.ErrorSearchMessage, { colors: colors, theme: theme },
                            `No results found for `,
                            react_1.default.createElement("b", null, `"${searchInput}"`))))))))),
        error && (react_1.default.createElement(Styles.ErrorText, { colors: colors, theme: theme }, error))));
}
//# sourceMappingURL=dropdown.js.map

/***/ }),

/***/ 780:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ErrorSearchMessage = exports.SearchContainer = exports.ErrorText = exports.SelectedOption = exports.ListItem = exports.DropdownScrollList = exports.DropdownList = exports.BottomSheetHeader = exports.DropdownListWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(__webpack_require__(63));
exports.Wrapper = styled_components_1.default.div `
  height: 48px;
  min-width: 320px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: ${(props) => props.theme.border.radius.large};
  padding: 0 ${(props) => props.theme.spacing[4]};
  border: 1px solid
    ${(props) => props.error ? props.colors.red.r400 : props.colors.neutral.n300};
  cursor: pointer;
  transition: top 0.5s ease;

  &::before {
    content: '${(props) => (props === null || props === void 0 ? void 0 : props.selected) && !(props === null || props === void 0 ? void 0 : props.showLabelAfterSelect) ? '' : props.label}';
    position: absolute;
    color: ${(props) => props.colors.neutral.n400};
    font-size: ${(props) => props.selected
    ? props.theme.typography.fonts.size.P2
    : props.theme.typography.fonts.size.P1};
    top: ${(props) => (props.selected ? '-48px' : '0')};
    bottom: 0;
    left: 12px;
    margin: auto;
    height: max-content;
    background: ${(props) => props.colors.primary.n0};
    padding: 0 4px;
    pointer-events: none;
    transition: all 0.2s ease;
  }

  &::after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    top: 0;
    bottom: 5px;
    right: 16px;
    margin: auto;
    border-radius: ${(props) => props.theme.border.radius.small};
    border: 2px solid ${(props) => props.colors.neutral.n500};
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    transform: rotate(45deg);
  }
`;
exports.DropdownListWrapper = styled_components_1.default.div `
  animation: fadeIn 0.2s ease;

  @media (max-width: 768px) {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: default;
    z-index: 1;
    background: ${(props) => props.colors.primary.n600}B3;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
exports.BottomSheetHeader = styled_components_1.default.div `
  display: none;
  align-items: center;
  height: 80px;
  color: ${(props) => props.colors.primary.n600};
  font-size: ${(props) => props.theme.typography.fonts.size.T2};
  font-weight: ${(props) => props.theme.typography.fonts.weight.T2};
  padding: 0 ${(props) => props.theme.spacing[6]};
  background: ${(props) => props.colors.primary.n0};
  position: sticky;
  top: 0;
  cursor: default;
  border-bottom: ${(props) => props.heading && `0.5px solid #e7e7f0;`};

  & > span::after {
    content: ${(props) => (props.hideClose ? null : "''")};
    position: absolute;
    width: 8px;
    height: 8px;
    top: -6px;
    bottom: 5px;
    right: 30px;
    margin: auto;
    cursor: pointer;
    border-radius: ${(props) => props.theme.border.radius.small};
    border: 2px solid ${(props) => props.colors.neutral.n500};
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    transform: rotate(45deg);
  }

  & > span::before {
    content: ${(props) => (props.hideClose ? null : "''")};
    position: absolute;
    width: 8px;
    height: 8px;
    top: 22px;
    bottom: 5px;
    right: 30px;
    margin: auto;
    cursor: pointer;
    border-radius: ${(props) => props.theme.border.radius.small};
    border: 2px solid ${(props) => props.colors.neutral.n500};
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    transform: rotate(-135deg);
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;
exports.DropdownList = styled_components_1.default.div `
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: rgb(8 12 41 / 10%) 0px 4px 35px;
  border-radius: ${(props) => props.theme.border.radius.large};
  z-index: 10;
  background: ${(props) => props.colors.primary.n0};
  cursor: default;
  padding: ${(props) => props.theme.spacing[2]} 0;
  z-index: 2;

  @media (max-width: 768px) {
    position: fixed;
    left: 0;
    top: 58vh;
    bottom: 0;
    margin: 0;
    padding: ${(props) => !props.hideHeader
    ? `0 ${props.theme.spacing[6]}`
    : props.theme.spacing[6]};
    border-radius: ${(props) => props.theme.border.radius.xLarge}
      ${(props) => props.theme.border.radius.xLarge} 0 0;
    transform: ${(props) => (props.closing ? 'translateY(0)' : null)};
    animation: slideUp 0.25s ease;
  }

  @keyframes slideUp {
    0% {
      transform: translateY(200px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
exports.DropdownScrollList = styled_components_1.default.div `
  overflow-y: auto;
  max-height: 250px;
`;
exports.ListItem = styled_components_1.default.div `
  cursor: pointer;
  padding: ${(props) => props.theme.spacing[2]}
    ${(props) => props.theme.spacing[4]};
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  color: ${(props) => props.selected ? props.colors.primary.g300 : props.colors.primary.n600};
  font-weight: ${(props) => props.selected
    ? props.theme.typography.fonts.weight.T4_M
    : props.theme.typography.fonts.weight.P2};

  &:hover {
    background: ${(props) => props.colors.neutral.n50};
  }

  @media (max-width: 768px) {
    border-bottom: 1px solid ${(props) => props.colors.neutral.n200};
    padding: ${(props) => props.theme.spacing[4]} 0;
  }
`;
exports.SelectedOption = styled_components_1.default.span `
  color: ${(props) => props.colors.primary.n600};
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  pointer-events: none;
`;
exports.ErrorText = styled_components_1.default.span `
  color: ${(props) => props.colors.red.r400};
  font-size: ${(props) => props.theme.typography.fonts.size.C1};
  position: absolute;
  left: 0;
  bottom: -18px;
  transition: all 0.5s ease;
  cursor: default;
`;
exports.SearchContainer = styled_components_1.default.div `
  margin: 0 16px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin: 0px;
  }
`;
exports.ErrorSearchMessage = styled_components_1.default.div `
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: ${(props) => props.theme.typography.fonts.weight.P1};
  font-size: ${(props) => props.theme.typography.fonts.size.T3};
  line-height: ${(props) => props.theme.typography.lineHeights.T2};
  color: ${(props) => props.theme.colors.light.primary.n600};
  margin: 0 16px;
`;
//# sourceMappingURL=dropdown.styles.js.map

/***/ }),

/***/ 9657:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.Lt = void 0;
var dropdown_1 = __webpack_require__(7648);
Object.defineProperty(exports, "Lt", ({ enumerable: true, get: function () { return dropdown_1.Dropdown; } }));
var common_dropdown_1 = __webpack_require__(3296);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return common_dropdown_1.CommonDropdown; } });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(1720));
const search_bar_styles_1 = __webpack_require__(9454);
const Search_1 = __importDefault(__webpack_require__(5061));
const Close_1 = __importDefault(__webpack_require__(7101));
const Back_1 = __importDefault(__webpack_require__(499));
const SearchBar = (props) => {
    const { placeholder = '', value = '', onChange, onFocus, onBack, inFocus = false, } = props;
    const [val, setVal] = (0, react_1.useState)(value);
    (0, react_1.useEffect)(() => {
        if (!inFocus) {
            setVal('');
        }
    }, [inFocus]);
    const handleChange = (e) => {
        var _a, _b;
        setVal((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        onChange((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value);
    };
    const handleFocus = () => {
        onFocus && onFocus();
    };
    const handleBack = (e) => {
        e.stopPropagation();
        setVal('');
        onBack && onBack();
    };
    return (react_1.default.createElement(search_bar_styles_1.SearchContainer, { focus: inFocus, theme: props.theme, colors: props.colors },
        !inFocus && react_1.default.createElement(Search_1.default, null),
        inFocus && (react_1.default.createElement(search_bar_styles_1.BackIconContainer, { onClick: handleBack },
            react_1.default.createElement(Back_1.default, null))),
        react_1.default.createElement(search_bar_styles_1.Input, { focus: inFocus, placeholder: placeholder, type: 'text', value: val, onChange: handleChange, onFocus: handleFocus }),
        val && (react_1.default.createElement(search_bar_styles_1.ClearIcon, { onClick: (e) => {
                e.stopPropagation();
                setVal('');
                onChange('');
            } },
            react_1.default.createElement(Close_1.default, null)))));
};
exports["default"] = SearchBar;
//# sourceMappingURL=search-bar.js.map

/***/ }),

/***/ 9454:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClearIcon = exports.BackIconContainer = exports.SearchIconContainer = exports.Input = exports.SearchContainer = void 0;
const building_blocks_ui_common_1 = __webpack_require__(9749);
const building_blocks_ui_theme_1 = __webpack_require__(549);
exports.SearchContainer = building_blocks_ui_common_1.styled.div `
  color: ${() => building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.n600};
  width: 100%;
  background: ${(props) => ((props === null || props === void 0 ? void 0 : props.focus) ? 'white' : '#f8f7fc')};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #040222;
  height: 48px;
  border: ${(props) => ((props === null || props === void 0 ? void 0 : props.focus) ? '1px solid' : '1px solid #f8f7fc')};
  margin-top: 14px;
`;
exports.Input = building_blocks_ui_common_1.styled.input `
  width: 100%;
  background: ${(props) => ((props === null || props === void 0 ? void 0 : props.focus) ? 'white' : '#f8f7fc')};
  border-radius: 8px;
  outline-style: none;
  border: none;
  font-weight: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.weight.C1};
  font-size: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.size.P1};
  line-height: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.lineHeights.P2};

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${() => building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.n600};
    font-weight: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.weight.C1};
    font-size: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.size.P1};
    line-height: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.lineHeights.P2};
    color: ${() => building_blocks_ui_theme_1.AckoMainTheme.colors.light.neutral.n400};
    opacity: 0.8;
  }
  :-ms-input-placeholder {
    color: ${() => building_blocks_ui_theme_1.AckoMainTheme.colors.light.primary.n600};
    font-weight: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.weight.C1};
    font-size: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.fonts.size.P1};
    line-height: ${() => building_blocks_ui_theme_1.AckoMainTheme.typography.lineHeights.P2};
    color: ${() => building_blocks_ui_theme_1.AckoMainTheme.colors.light.neutral.n400};
    opacity: 0.8;
  }
`;
exports.SearchIconContainer = building_blocks_ui_common_1.styled.div `
  cursor: pointer;
  padding: 0 10px 0 20px;
`;
exports.BackIconContainer = building_blocks_ui_common_1.styled.div `
  cursor: pointer;
  padding: 4px 2px 0 15px;
`;
exports.ClearIcon = building_blocks_ui_common_1.styled.div `
  cursor: pointer;
  padding: 4px 15px 0 15px;
`;
//# sourceMappingURL=search-bar.styles.js.map

/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CrossIcon = CrossIcon;
const React = __importStar(__webpack_require__(1720));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const f = () => ({
    __html: `<?xml version="1.0" encoding="UTF-8"?>
    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: sketchtool 55.2 (78181) - https://sketchapp.com -->
        <title>0A266906-753B-4A95-90A7-5ECB6673090C@3x</title>
        <desc>Created with sketchtool.</desc>
        <g id="Rough" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Find-Your-Car---Select-Car-Modal---Not-Found" transform="translate(-40.000000, -133.000000)">
                <g id="Select-Car" transform="translate(0.000000, 44.000000)">
                    <g id="Group" transform="translate(20.000000, 72.000000)">
                        <g id="Search-2" transform="translate(20.000000, 17.000000)">
                            <rect id="Rectangle" x="0" y="0" width="16" height="16"></rect>
                            <circle id="Oval" stroke="#5C5D66" stroke-linecap="round" stroke-linejoin="round" cx="7.20533333" cy="7.20533333" r="5.968"></circle>
                            <path d="M11.424,11.424 L14.768,14.768" id="Path" stroke="#5C5D66" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>`,
});
const StyledSpan = building_blocks_ui_common_1.styled.span `
  ${(props) => props.styles}
  ${(props) => props.onClick}
`;
function CrossIcon({ styles }) {
    return (React.createElement(StyledSpan, { styles: styles, dangerouslySetInnerHTML: {
            __html: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.74 1.5C4.74146 1.5 1.5 4.74146 1.5 8.74C1.5 12.7385 4.74146 15.98 8.74 15.98C12.7385 15.98 15.98 12.7385 15.98 8.74C15.98 4.74146 12.7385 1.5 8.74 1.5ZM0 8.74C0 3.91303 3.91303 0 8.74 0C13.567 0 17.48 3.91303 17.48 8.74C17.48 13.567 13.567 17.48 8.74 17.48C3.91303 17.48 0 13.567 0 8.74Z" fill="#5B5675"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5005 5.98047C11.7934 6.27337 11.7934 6.74824 11.5005 7.04113L7.04119 11.5005C6.74829 11.7934 6.27342 11.7934 5.98053 11.5005C5.68763 11.2076 5.68763 10.7327 5.98053 10.4398L10.4399 5.98047C10.7328 5.68758 11.2076 5.68758 11.5005 5.98047Z" fill="#5B5675"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5005 11.5005C11.2076 11.7934 10.7328 11.7934 10.4399 11.5005L5.98053 7.04113C5.68763 6.74824 5.68763 6.27337 5.98053 5.98047C6.27342 5.68758 6.74829 5.68758 7.04119 5.98047L11.5005 10.4398C11.7934 10.7327 11.7934 11.2076 11.5005 11.5005Z" fill="#5B5675"/>
                </svg>`,
        } }));
}
const Img = ({ styles }) => {
    return React.createElement(StyledSpan, { styles: styles, dangerouslySetInnerHTML: f() });
};
exports["default"] = Img;
//# sourceMappingURL=Icon.js.map

/***/ }),

/***/ 8210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var searchInput_1 = __webpack_require__(9014);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(searchInput_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = SearchInput;
const react_1 = __importStar(__webpack_require__(1720));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const building_blocks_ui_common_2 = __webpack_require__(9749);
const Icon_1 = __importStar(__webpack_require__(8222));
const StyledInput = building_blocks_ui_common_1.styled.input `
  height: 50px;
  width: 100%;
  border-radius: 8px;
  color: ${building_blocks_ui_common_2.$neutralColors.normal};
  font-size: ${building_blocks_ui_common_2.$fontSize.xxs};
  background-color: ${building_blocks_ui_common_2.$grayLight};
  border: 1px solid ${building_blocks_ui_common_2.$grayLight};
  padding-left: 45px;
  -webkit-appearance: none;
  ${(props) => props.backgroundColor ? `background-color: ${props.backgroundColor}` : ''}
  :focus {
    outline: none;
    border: 1px solid
      ${(props) => (props.error ? building_blocks_ui_common_2.$error : building_blocks_ui_common_2.$primaryColors.normal)};
  }
`;
const Container = building_blocks_ui_common_1.styled.div `
  position: relative;
`;
const styledSearchIcon = `
  position: absolute;
  left: 17px;
  top: 17px;
`;
const styledCrossIcon = `
  position: absolute;
  right: 1rem;
  top: 1rem;
`;
// https://styled-components.com/docs/basics#styling-any-component
function SearchInput(props) {
    var _a;
    const timerRef = (0, react_1.useRef)(null);
    const styledInputRef = (0, react_1.useRef)(null);
    const onInputChange = (event) => {
        event.persist();
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            props.handleChange(event.target.value);
        }, 300);
    };
    const handleCrossClick = (e) => {
        // Clearing the search if clicked on crossIcon
        e === null || e === void 0 ? void 0 : e.preventDefault();
        props === null || props === void 0 ? void 0 : props.handleChange('');
        if (styledInputRef === null || styledInputRef === void 0 ? void 0 : styledInputRef.current) {
            styledInputRef.current.value = '';
        }
    };
    // only show cross icon if there is input value 
    const inputValue = (_a = styledInputRef === null || styledInputRef === void 0 ? void 0 : styledInputRef.current) === null || _a === void 0 ? void 0 : _a.value;
    return (react_1.default.createElement(Container, { className: props.className },
        react_1.default.createElement(StyledInput, { error: props.error, onChange: onInputChange, onFocus: props.onFocus, type: "text", placeholder: props.placeholder, backgroundColor: props.backgroundColor, autoFocus: props.autoFocus, ref: styledInputRef }),
        react_1.default.createElement(Icon_1.default, { styles: styledSearchIcon }),
        (props === null || props === void 0 ? void 0 : props.showCrossIcon) && inputValue && (react_1.default.createElement("div", { onClick: handleCrossClick },
            react_1.default.createElement(Icon_1.CrossIcon, { styles: styledCrossIcon })))));
}
//# sourceMappingURL=searchInput.js.map

/***/ }),

/***/ 9231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getDealerDashboard": function() { return /* binding */ getDealerDashboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92);
/* harmony import */ var utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4733);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2729);





var getDealerDashboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(partnerId, groupName, page, tab, journey, search) {
        var ref, status, data, e, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partnerId, "/dealer-dashboard?group_name=").concat(groupName),
                            params: {
                                page: page,
                                status: search ? "" : tab,
                                journey: journey,
                                customer_phone_or_name_or_serial_number: search
                            }
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        return [
                            2,
                            {
                                data: data,
                                status: true
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        window.location.href = "/login";
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getDealerDashboard(partnerId, groupName, page, tab, journey, search) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ gstDetailsUpdateModal; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(63);
;// CONCATENATED MODULE: ./components/dashboard/gstDetailsUpdateModal/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0;\n    margin-top: -8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #ff0000;\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin-left: 10px;\n\n    @media screen and (min-width: 769px) {\n        font-size: 1.9rem;\n        font-weight: 600;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 5px 0;\n    font-weight: 400;\n    font-size: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 10px 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm["default"].div(_templateObject());
var WarningTitleContainer = styled_components_browser_esm["default"].div(_templateObject1());
var WarningTitleText = styled_components_browser_esm["default"].h1(_templateObject2());
var Text = styled_components_browser_esm["default"].p(_templateObject3());
var ButtonContainer = styled_components_browser_esm["default"].div(_templateObject4());

// EXTERNAL MODULE: ./utils/date/index.ts + 37 modules
var date = __webpack_require__(4679);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.button/dist/index.js
var dist = __webpack_require__(2518);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
;// CONCATENATED MODULE: ./components/dashboard/gstDetailsUpdateModal/index.tsx









var GSTDetailsUpdateModal = function() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), userDetails = ref.userDetails, gstDetailsSubmitAction = ref.gstDetailsSubmitAction;
    var currentDate = new Date();
    var router = (0,next_router.useRouter)();
    var onClickContinueHandler = function() {
        if (!gstDetailsSubmitAction) {
            router.push("/logout");
        } else {
            router.push("/embedded/".concat(userDetails.partner_id, "/gst-details"));
        }
    };
    if (!gstDetailsSubmitAction) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(WarningTitleContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: (0,generics/* getImageBasePath */.m4)("/icons/errorRed.svg"),
                            alt: "",
                            width: 25,
                            height: 25
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WarningTitleText, {
                            children: "Urgent: Your GST has expired"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Text, {
                    children: "GST number for your dealer is invalid or expired. To continue transacting on Acko, request your dealer to kindly update the GST number. Once the dealer completes this step, you will be able to start selling plans."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.PrimaryButton, {
                        style: {
                            width: "100px"
                        },
                        isFullWidth: false,
                        size: "large",
                        onClick: onClickContinueHandler,
                        children: "Logout"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(WarningTitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)("/icons/errorRed.svg"),
                        alt: "",
                        width: 25,
                        height: 25
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WarningTitleText, {
                        children: "Urgent: Your GST has expired"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Text, {
                children: [
                    "We checked your GST number on ",
                    (0,date/* getDD_MM_YYYY */.PZ)(currentDate),
                    " and it's no longer valid. To continue creating new plans and earning commissions, you need to update GST details."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.PrimaryButton, {
                    style: {
                        width: "100px"
                    },
                    isFullWidth: false,
                    size: "large",
                    onClick: onClickContinueHandler,
                    children: "Continue"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Text, {
                children: "You won't be able to create new plans until your GST is updated"
            })
        ]
    });
};
/* harmony default export */ var gstDetailsUpdateModal = (GSTDetailsUpdateModal);


/***/ }),

/***/ 8674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dashboard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.modal/dist/index.js
var dist = __webpack_require__(5251);
// EXTERNAL MODULE: ./widgets/header/index.tsx + 1 modules
var header = __webpack_require__(9015);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.acko-analytics/dist/index.js
var building_blocks_ui_acko_analytics_dist = __webpack_require__(4262);
// EXTERNAL MODULE: ./hooks/useFetchParams.ts
var useFetchParams = __webpack_require__(6982);
// EXTERNAL MODULE: ./utils/responsive/index.tsx
var responsive = __webpack_require__(1798);
// EXTERNAL MODULE: ./hooks/usePermissionHook.ts
var usePermissionHook = __webpack_require__(7664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./utils/api/services.ts + 1 modules
var services = __webpack_require__(1349);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
// EXTERNAL MODULE: ./utils/segment/constants.ts
var constants = __webpack_require__(7316);
// EXTERNAL MODULE: ./widgets/cards/iconTextArrow/index.tsx + 1 modules
var iconTextArrow = __webpack_require__(1268);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./components/dashboard/newPlan/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var NewPlanWrapper = building_blocks_ui_common_dist.styled.div(_templateObject());

;// CONCATENATED MODULE: ./components/dashboard/newPlan/index.tsx














function NewPlan() {
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, userDetails = ref.userDetails, permissions = ref.permissions, setGstDetailsValid = ref.setGstDetailsValid;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var purchaseJourney = permissions.purchase_journey;
    var getPartnerIdFromPermission = (0,usePermissionHook/* default */.Z)().getPartnerIdFromPermission;
    var onClickNewPlan = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, gstValidationResponse, _data, required, valid;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,services.callValidateGSTDetails)(getPartnerIdFromPermission(), permissions.group, true)
                        ];
                    case 1:
                        gstValidationResponse = _state.sent();
                        if (!gstValidationResponse.is_error) {
                            if (gstValidationResponse.data) {
                                _data = gstValidationResponse.data, required = _data.required, valid = _data.valid;
                                if (required && !valid) {
                                    setGstDetailsValid(false);
                                    return [
                                        2
                                    ];
                                }
                                setGstDetailsValid(true);
                            }
                        }
                        router.push("/".concat(lob, "/").concat(userDetails.partner_id, "/new-plan"));
                        /**
         * Segment event
         */ (0,building_blocks_ui_acko_analytics_dist.trackEvent)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
                            page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
                            button_name: constants/* SegmentEventButtonNames.CREATE_NEW_PLAN */.A3.CREATE_NEW_PLAN,
                            product: constants/* PRODUCT */.c5,
                            sub_product: constants/* SUB_PRODUCT_NAME */.tM,
                            platform: isMobile ? "mweb" : "web",
                            device: navigator.userAgent || "",
                            partner: partnerId,
                            action_name: constants/* SegmentEventActionNames.CREATE_NEW_PLAN */.iV.CREATE_NEW_PLAN
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickNewPlan() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewPlanWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(iconTextArrow/* default */.Z, {
            icon: purchaseJourney === "v1" ? "/icons/note.svg" : "/icons/claim.svg",
            text: "Create new plan",
            backgroundColor: "161.3deg, #FFF7E5 -2.04%, #FBE9F6 102.81%",
            onClick: onClickNewPlan,
            iconBackground: purchaseJourney === "v1" ? "transparent" : "161.3deg, #FFF7E5 -2.04%, #FBE9F6 102.81%"
        })
    });
}
/* harmony default export */ var newPlan = (NewPlan);

// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(8533);
// EXTERNAL MODULE: ./utils/date/index.ts + 37 modules
var date = __webpack_require__(4679);
// EXTERNAL MODULE: ./widgets/tab/index.tsx + 1 modules
var tab = __webpack_require__(89);
;// CONCATENATED MODULE: ./components/dashboard/transactions/constants.ts
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["ORDER_CREATED"] = "ORDER_CREATED";
    OrderStatus["CUSTOMER_LINK_SHARED"] = "CUSTOMER_LINK_SHARED";
    OrderStatus["CUSTOMER_DETAILS_UPDATED"] = "CUSTOMER_DETAILS_UPDATED";
    OrderStatus["PAYMENT_INITIATED_BY_CUSTOMER"] = "PAYMENT_INITIATED_BY_CUSTOMER";
    OrderStatus["PAYMENT_INITIATED_BY_DEALER"] = "PAYMENT_INITIATED_BY_DEALER";
    OrderStatus["ORDER_LINK_EXPIRED"] = "ORDER_LINK_EXPIRED";
    OrderStatus["PAYMENT_SUCCESS_BY_DEALER"] = "PAYMENT_SUCCESS_BY_DEALER";
    OrderStatus["POLICY_CREATED"] = "POLICY_CREATED";
    OrderStatus["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    OrderStatus["PAYMENT_SUCCESS_BY_CUSTOMER"] = "PAYMENT_SUCCESS_BY_CUSTOMER";
})(OrderStatus || (OrderStatus = {}));
var DEALER_CANCELLABLE_ORDER_STATUSES = new Set([
    OrderStatus.ORDER_CREATED,
    OrderStatus.CUSTOMER_LINK_SHARED,
    OrderStatus.CUSTOMER_DETAILS_UPDATED,
    OrderStatus.PAYMENT_INITIATED_BY_CUSTOMER,
    OrderStatus.PAYMENT_INITIATED_BY_DEALER, 
]);
var isDealerCancellableOrderStatus = function(status) {
    return DEALER_CANCELLABLE_ORDER_STATUSES.has(status);
};

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.button/dist/index.js
var building_blocks_ui_button_dist = __webpack_require__(2518);
// EXTERNAL MODULE: ./utils/constants/index.ts
var utils_constants = __webpack_require__(1485);
// EXTERNAL MODULE: ./components/newPlan/constants.ts
var newPlan_constants = __webpack_require__(5327);
;// CONCATENATED MODULE: ./components/dashboard/transactions/detailsModal/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n    margin-top: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 14px;\n    background: ",
        ";\n    border-radius: 4px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: ",
        ";\n    padding: 6px;\n    width: fit-content;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    padding: 12px;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 12px;\n    margin-top: 26px;\n    border: 1px solid #e7e7f0;\n    box-sizing: border-box;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 10px;\n    align-items: flex-start;\n    gap: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    min-width: 0;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    min-width: 0;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    text-align: end;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    opacity: 0.1;\n    border: 1px solid #040222;\n    margin-top: 10px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 24px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    flex-direction: column;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 6px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    align-items: flex-end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #1b73e8;\n    justify-content: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var Wrapper = building_blocks_ui_common_dist.styled.div(styles_templateObject());
var ModalName = building_blocks_ui_common_dist.styled.div(_templateObject1());
var LastUpdatedDate = building_blocks_ui_common_dist.styled.div(_templateObject2());
var StatusText = building_blocks_ui_common_dist.styled.div(_templateObject3(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});
var PlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(_templateObject4());
var RowWrapper = building_blocks_ui_common_dist.styled.div(_templateObject5());
var LabelText = building_blocks_ui_common_dist.styled.div(_templateObject6());
var ValueText = building_blocks_ui_common_dist.styled.div(_templateObject7());
var Hr = building_blocks_ui_common_dist.styled.div(_templateObject8());
var CustomerDetailsWrapper = building_blocks_ui_common_dist.styled.div(_templateObject9());
var CustomerMobileFlex = building_blocks_ui_common_dist.styled.div(_templateObject10());
var CustomerMobileText = building_blocks_ui_common_dist.styled.div(_templateObject11());
var CustomerMobileNumber = building_blocks_ui_common_dist.styled.div(_templateObject12());
var CustomerAmountFlex = (0,building_blocks_ui_common_dist.styled)(CustomerMobileFlex)(_templateObject13());
var ResendLinkWrapper = building_blocks_ui_common_dist.styled.div(_templateObject14());
var ResendLinkText = building_blocks_ui_common_dist.styled.div(_templateObject15());

;// CONCATENATED MODULE: ./components/dashboard/transactions/detailsModal/index.tsx








var TabOptions;
(function(TabOptions) {
    TabOptions["PENDING"] = "Pending";
    TabOptions["COMPLETED"] = "Completed";
})(TabOptions || (TabOptions = {}));
function TransactionDetailsModal(param) {
    var selectedTab = param.selectedTab, deviceName = param.deviceName, lastUpdatedAt = param.lastUpdatedAt, status = param.status, statusMessage = param.statusMessage, serialNumber = param.serialNumber, planName = param.planName, coverage = param.coverage, mobileNumber = param.mobileNumber, amount = param.amount, deviceCategory = param.deviceCategory, onClick = param.onClick, isBtnLoading = param.isBtnLoading, vin = param.vin;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var getColors = function() {
        switch(status){
            case OrderStatus.ORDER_CREATED:
                return {
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            default:
                return {
                    color: "#D83D37",
                    background: "#FBEAEA"
                };
        }
    };
    var ref = getColors(), background = ref.background, color = ref.color;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalName, {
                children: deviceName
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LastUpdatedDate, {
                children: [
                    "Last updated ",
                    (0,date/* getHHMM */["in"])(lastUpdatedAt)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StatusText, {
                background: background,
                color: color,
                children: statusMessage || status
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PlanDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelText, {
                                children: "Device model"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                children: deviceName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {}),
                    lob === utils_constants/* LOB.EMBEDDED */.r6.EMBEDDED && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelText, {
                                        children: deviceCategory === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE || deviceCategory === newPlan_constants/* DeviceCategory.TABLET */.I_.TABLET ? "IMEI" : "Serial Number"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: serialNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelText, {
                                        children: "Plan Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: planName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelText, {
                                        children: "What’s covered"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: coverage
                                    })
                                ]
                            }),
                            " "
                        ]
                    }),
                    lob === utils_constants/* LOB.AUTO */.r6.AUTO && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelText, {
                                        children: "VIN"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: vin
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LabelText, {
                                        children: "Plan Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ValueText, {
                                        children: planName
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerMobileFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerMobileText, {
                                children: "Customer mobile number"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerMobileNumber, {
                                children: mobileNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerAmountFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerMobileFlex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CustomerMobileText, {
                                    children: "Amount"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CustomerMobileNumber, {
                                    children: [
                                        "₹",
                                        amount
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            selectedTab === TabOptions.PENDING && status !== OrderStatus.ORDER_LINK_EXPIRED && status !== OrderStatus.PAYMENT_SUCCESS_BY_DEALER && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ResendLinkWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isBtnLoading,
                    isFullWidth: true,
                    size: "medium",
                    onClick: function() {
                        return onClick(status === OrderStatus.ORDER_CREATED ? "resend" : "pay_acko");
                    },
                    children: status === OrderStatus.ORDER_CREATED ? "Resend link" : "Pay Acko"
                })
            }),
            selectedTab === TabOptions.PENDING && status !== OrderStatus.ORDER_CREATED && status !== OrderStatus.ORDER_LINK_EXPIRED && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ResendLinkText, {
                onClick: function() {
                    return onClick("resend");
                },
                children: "Resend link"
            })
        ]
    });
}
/* harmony default export */ var detailsModal = (TransactionDetailsModal);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
;// CONCATENATED MODULE: ./components/dashboard/transactions/itemCard/styles.ts

function itemCard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 10px;\n"
    ]);
    itemCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 9;\n    flex-direction: column;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    align-items: center;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n    ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    margin-top: 4px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    justify-content: flex-end;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 2px 6px;\n    border-radius: 4px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var styles_Wrapper = building_blocks_ui_common_dist.styled.div(itemCard_styles_templateObject());
var DivFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject1());
var RightArrowIconFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject2());
var RowFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject3());
var Value1 = building_blocks_ui_common_dist.styled.div(styles_templateObject4());
var Value2 = building_blocks_ui_common_dist.styled.div(styles_templateObject5(), function(props) {
    return props.label && "font-weight: 400;\n        font-size: 14px;\n    ";
});
var Value3 = building_blocks_ui_common_dist.styled.div(styles_templateObject6());
var Value4 = building_blocks_ui_common_dist.styled.div(styles_templateObject7());
var Value4BackgroundText = building_blocks_ui_common_dist.styled.div(styles_templateObject8(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});

;// CONCATENATED MODULE: ./components/dashboard/transactions/itemCard/index.tsx




function TransactionItemCard(param) {
    var value1 = param.value1, value2 = param.value2, value3 = param.value3, value4 = param.value4, labelColor = param.labelColor;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(DivFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value1, {
                                children: value1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value2, {
                                label: labelColor,
                                children: value2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value3, {
                                children: value3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value4, {
                                children: (labelColor === null || labelColor === void 0 ? void 0 : labelColor.background) ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Value4BackgroundText, {
                                    background: labelColor.background,
                                    color: labelColor.color,
                                    children: value4
                                }) : value4
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RightArrowIconFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "12px",
                    height: "12px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/rightArrow.svg")
                })
            })
        ]
    });
}
/* harmony default export */ var itemCard = (TransactionItemCard);

// EXTERNAL MODULE: ./library/snackbar/index.tsx + 1 modules
var library_snackbar = __webpack_require__(6241);
// EXTERNAL MODULE: ./hooks/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9047);
;// CONCATENATED MODULE: ./components/dashboard/transactions/styles.ts

function transactions_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    transactions_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #000000;\n"
    ]);
    transactions_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 10px;\n"
    ]);
    transactions_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 6px 0;\n"
    ]);
    transactions_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    height: 0;\n    border: 1px solid #e7e7f0;\n"
    ]);
    transactions_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function transactions_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    transactions_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var transactions_styles_Wrapper = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject());
var AllTransactionText = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject1());
var TabWrapper = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject2());
var ItemCardWrapper = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject3());
var styles_Hr = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject4());
var NoResult = building_blocks_ui_common_dist.styled.div(transactions_styles_templateObject5());

;// CONCATENATED MODULE: ./components/dashboard/transactions/index.tsx






















var transactions_TabOptions;
(function(TabOptions) {
    TabOptions["PENDING"] = "Pending";
    TabOptions["COMPLETED"] = "Completed";
})(transactions_TabOptions || (transactions_TabOptions = {}));
function OrderHistory(param) {
    var pendingOrders = param.pendingOrders, completedOrders = param.completedOrders, hasMorePending = param.hasMorePending, hasMoreCompleted = param.hasMoreCompleted, onLoadMore = param.onLoadMore;
    var ref, ref1, ref2, ref3;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref4 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref4.partnerId, dealerType = ref4.dealerType;
    var ref5 = (0,compat_module.useState)(null), selectedOrder = ref5[0], setSelectedOrder = ref5[1];
    var ref6 = (0,compat_module.useState)(transactions_TabOptions.PENDING), selectedTab = ref6[0], setSelectedTab = ref6[1];
    var ref7 = (0,compat_module.useState)(false), modalStatus = ref7[0], setModalStatus = ref7[1];
    var ref8 = (0,compat_module.useState)(false), isBtnLoading = ref8[0], setIsBtnLoading = ref8[1];
    var ref9 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref9[0], setSnackbar = ref9[1];
    (0,compat_module.useEffect)(function() {
        var eventName = selectedTab === transactions_TabOptions.PENDING ? constants/* SegmentTrackEvents.TAP_CTA_PENDING */.Jk.TAP_CTA_PENDING : constants/* SegmentTrackEvents.TAP_CTA_COMPLETED */.Jk.TAP_CTA_COMPLETED;
        (0,building_blocks_ui_acko_analytics_dist.trackEvent)(eventName, {
            page: constants/* SegmentPages.DASHBOARD */.IT.DASHBOARD,
            partner: partnerId,
            product: "pos",
            journey: "buy",
            platform: "mweb",
            type: dealerType
        });
    }, [
        selectedTab
    ]);
    var onSelectTab = function(option) {
        setSelectedTab(option);
    };
    var getActiveOrdersList = function() {
        if (selectedTab === transactions_TabOptions.COMPLETED) {
            return completedOrders;
        }
        return pendingOrders;
    };
    var onClickOrder = function(order) {
        setModalStatus(true);
        setSelectedOrder(order);
    };
    var orderStatus = function(status, statusMessage) {
        switch(status){
            case OrderStatus.ORDER_CREATED:
                return {
                    text: "Link sent",
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            default:
                return {
                    text: statusMessage,
                    color: "#D83D37",
                    background: "#FBEAEA"
                };
        }
    };
    var getValueObjects = function(order) {
        if (selectedTab === transactions_TabOptions.PENDING) {
            var ref = orderStatus(order.status, order.status_message), text = ref.text, color = ref.color, background = ref.background;
            return {
                value1: order.device.name,
                value2: (0,date/* getDD_Month_Time */.Se)(new Date(order.updated_on)),
                value3: order.customer.phone,
                value4: text,
                labelColor: {
                    color: color,
                    background: background
                }
            };
        }
        return {
            value1: order.customer.name,
            value2: "₹".concat(order.plan.premium),
            value3: order.device.name,
            value4: order.device.purchase_date
        };
    };
    var segmentEvent = function(status) {
        try {
            var eventName = status === "resend" ? constants/* SegmentTrackEvents.TAP_CTA_RESEND_LINK */.Jk.TAP_CTA_RESEND_LINK : constants/* SegmentTrackEvents.TAP_CTA_PAY_ACKO */.Jk.TAP_CTA_PAY_ACKO;
            (0,building_blocks_ui_acko_analytics_dist.trackEvent)(eventName, {
                page: constants/* SegmentPages.DASHBOARD */.IT.DASHBOARD,
                partner: partnerId,
                product: "pos",
                journey: "buy",
                platform: "mweb",
                type: dealerType
            });
        } catch (e) {}
    };
    var onClick = function(status) {
        if (!selectedOrder) return;
        segmentEvent(status);
        if (status === "pay_acko") {
            router.push("/".concat(lob, "/").concat(partnerId, "/payment?order_ekey=").concat(selectedOrder.ekey));
            return;
        }
        if (navigator.share && partnerId === "hero_vida") {
            var baseOrigin = window.location.origin;
            var baseUrl = "https://www.acko.com";
            if (baseOrigin.includes("ackodev")) baseUrl = "https://www.ackodev.com";
            navigator.share({
                title: "Share payment link",
                url: "".concat(baseUrl, "/mpos/partner/hero_vida?order_ekey=").concat(selectedOrder.ekey, "&phone=").concat(selectedOrder.customer.phone)
            }).then(function() {
                return console.log("shared");
            }).catch(function(error) {
                return console.log("error", error);
            });
            return;
        }
        __webpack_require__.e(/* import() */ 620).then(__webpack_require__.bind(__webpack_require__, 3620)).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                var ref, _$status, statusCode, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsBtnLoading(true);
                            return [
                                4,
                                req.resendLinkToCustomer(partnerId, (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.ekey) || "")
                            ];
                        case 1:
                            ref = _state.sent(), _$status = ref.status, statusCode = ref.statusCode, errorMessage = ref.errorMessage;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            setIsBtnLoading(false);
                            if (_$status) {
                                setSnackbar({
                                    type: "success",
                                    message: "Payment link has sent successfully."
                                });
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: errorMessage || "Oops. Something went wrong."
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var Modal = isMobile ? dist.ModalMobile : dist.ModalDesktop;
    // ModalMobile doesn't read these props, but keep them desktop-only so
    // the mobile bottom sheet stays intentionally full-width and isn't
    // coupled to a desktop-only layout constant.
    var desktopModalWidthProps = isMobile ? {} : {
        maxWidth: "560px",
        minimumWidth: "560px"
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(transactions_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AllTransactionText, {
                children: "All transactions"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(tab/* default */.Z, {
                    items: [
                        transactions_TabOptions.PENDING,
                        transactions_TabOptions.COMPLETED
                    ],
                    color: "#0FA457",
                    selectedTab: selectedTab,
                    onSelectTab: onSelectTab
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: getActiveOrdersList().length === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NoResult, {
                    children: "No transactions"
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                    dataLength: getActiveOrdersList().length,
                    next: function() {
                        return onLoadMore(selectedTab.toLowerCase());
                    },
                    hasMore: selectedTab === transactions_TabOptions.PENDING ? hasMorePending : hasMoreCompleted,
                    loader: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                    children: getActiveOrdersList().map(function(order, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ItemCardWrapper, {
                            onClick: function() {
                                return onClickOrder(order);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(itemCard, (0,_object_spread/* default */.Z)({}, getValueObjects(order))),
                                index !== getActiveOrdersList().length - 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Hr, {})
                            ]
                        }, order.ekey);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: modalStatus,
                onHide: function() {
                    return setModalStatus(false);
                },
                padding: "20px"
            }, desktopModalWidthProps), {
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: selectedOrder && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(detailsModal, {
                    selectedTab: selectedTab,
                    deviceName: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref = selectedOrder.device) === null || ref === void 0 ? void 0 : ref.name,
                    lastUpdatedAt: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.updated_on,
                    status: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.status,
                    statusMessage: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.status_message,
                    serialNumber: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref1 = selectedOrder.device) === null || ref1 === void 0 ? void 0 : ref1.serial_number,
                    planName: (0,generics/* getPlanName */.s0)(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.plan.plan_name),
                    mobileNumber: selectedOrder.customer.phone,
                    amount: selectedOrder.plan.premium,
                    deviceCategory: selectedOrder.device.category,
                    coverage: (0,generics/* whatsCoverText */.oX)((ref2 = selectedOrder.plan.plan_category) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                    onClick: onClick,
                    isBtnLoading: isBtnLoading,
                    vin: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref3 = selectedOrder.device) === null || ref3 === void 0 ? void 0 : ref3.vin
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var transactions = (OrderHistory);

// EXTERNAL MODULE: ./utils/styles/index.ts
var styles = __webpack_require__(7631);
// EXTERNAL MODULE: ./widgets/errorScreen/index.tsx + 1 modules
var errorScreen = __webpack_require__(8269);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(63);
;// CONCATENATED MODULE: ./components/dashboard/styles.ts

function dashboard_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    from {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"
    ]);
    dashboard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dashboard_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media (prefers-reduced-motion: no-preference) {\n        ",
        "\n    }\n"
    ]);
    dashboard_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dashboard_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    min-height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    box-sizing: border-box;\n\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    dashboard_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function dashboard_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        animation: ",
        " 0.35s ease-out;\n    "
    ]);
    dashboard_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function dashboard_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    ",
        "\n"
    ]);
    dashboard_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function dashboard_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n            /* "backwards" (not "both") on purpose: "both" would leave a\n               non-none transform on this element permanently after the\n               animation ends, which creates a new containing block for any\n               position:fixed descendant (e.g. the transaction details\n               modal), pinning it near the top of this section instead of\n               centering in the real viewport. */\n            animation: ',
        " 0.35s ease-out backwards;\n            animation-delay: ",
        "s;\n        "
    ]);
    dashboard_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function dashboard_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    ",
        "\n"
    ]);
    dashboard_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var fadeSlideUp = (0,styled_components_browser_esm.keyframes)(dashboard_styles_templateObject());
var motionSafe = function(styles) {
    return (0,styled_components_browser_esm.css)(dashboard_styles_templateObject1(), styles);
};
var dashboard_styles_Wrapper = styled_components_browser_esm["default"].div(dashboard_styles_templateObject2());
var Content = styled_components_browser_esm["default"].div(dashboard_styles_templateObject4(), motionSafe((0,styled_components_browser_esm.css)(dashboard_styles_templateObject3(), fadeSlideUp)));
var Section = styled_components_browser_esm["default"].div(dashboard_styles_templateObject6(), function(param) {
    var $index = param.$index;
    return typeof $index === "number" && motionSafe((0,styled_components_browser_esm.css)(dashboard_styles_templateObject5(), fadeSlideUp, Math.min($index, 4) * 0.06));
});

// EXTERNAL MODULE: ./utils/localStorage/partnerStorage.js
var partnerStorage = __webpack_require__(1246);
;// CONCATENATED MODULE: ./components/dashboard/legalDocumentPending/styles.ts

function legalDocumentPending_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 20px;\n"
    ]);
    legalDocumentPending_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n"
    ]);
    legalDocumentPending_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    text-align: center;\n"
    ]);
    legalDocumentPending_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    margin-top: 20px;\n    width: 100%;\n    max-width: 220px;\n"
    ]);
    legalDocumentPending_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function legalDocumentPending_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    button {\n        width: 100%;\n    }\n"
    ]);
    legalDocumentPending_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var legalDocumentPending_styles_Wrapper = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject());
var TextWrapper = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject1());
var Text = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject2());
var Actions = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject3());
var ActionButton = styled_components_browser_esm["default"].div(legalDocumentPending_styles_templateObject4());

;// CONCATENATED MODULE: ./components/dashboard/legalDocumentPending/index.tsx









function LegalDocumentPendingState() {
    var router = (0,next_router.useRouter)();
    var userAccessList = (0,compat_module.useContext)(context/* MPosContext */.w).userAccessList;
    var ref = (0,compat_module.useState)(false), isSwitchingPartner = ref[0], setIsSwitchingPartner = ref[1];
    var accessList = (userAccessList === null || userAccessList === void 0 ? void 0 : userAccessList.length) > 0 ? userAccessList : (0,partnerStorage/* getUserAccess */.Fu)();
    var uniquePartnerIds = new Set((accessList || []).map(function(access) {
        return access === null || access === void 0 ? void 0 : access.partner_id;
    }).filter(Boolean));
    var hasMultiplePartners = uniquePartnerIds.size > 1;
    var onSwitchBrand = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSwitchingPartner(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        (0,partnerStorage/* setPartnerNavState */.sy)(partnerStorage/* PARTNER_NAV_STATES.SELECTING */.I0.SELECTING);
                        return [
                            4,
                            router.push("/partners")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsSwitchingPartner(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSwitchBrand() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocumentPending_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TextWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Text, {
                    children: "We have requested your dealer to submit the bank and GST details."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Text, {
                    children: "Once the dealer completes this step, you will be able to start selling the plans."
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Actions, {
                    children: [
                        hasMultiplePartners ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ActionButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.SecondaryButton, {
                                onClick: onSwitchBrand,
                                disabled: isSwitchingPartner,
                                children: isSwitchingPartner ? "Switching..." : "Switch brand"
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ActionButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                                onClick: function() {
                                    return router.push("/logout");
                                },
                                disabled: isSwitchingPartner,
                                children: "Logout"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var legalDocumentPending = (LegalDocumentPendingState);

// EXTERNAL MODULE: ./hooks/useSegmentView.ts
var useSegmentView = __webpack_require__(5122);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 50 modules
var axios = __webpack_require__(2729);
// EXTERNAL MODULE: ./utils/serverConfig/index.ts
var serverConfig = __webpack_require__(4733);
;// CONCATENATED MODULE: ./components/dashboard/commissionEarned/api.ts







var getCommissionAmount = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId) {
        var requestBody, response, data, status, commissionData, e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestBody = {
                        from_date: (0,date/* getDD_MM_YYYY */.PZ)(new Date()),
                        to_date: (0,date/* getDD_MM_YYYY */.PZ)(new Date()),
                        page: 0,
                        group_by: "DATE"
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,axios/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/order/commission-summary")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: requestBody
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    data = response.data, status = response.status;
                    if (status === 200) {
                        commissionData = data.data;
                        return [
                            2,
                            {
                                amount: commissionData.length > 0 ? commissionData[0].commission_earned : 0,
                                status: true
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                        window.location.href = "/login";
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCommissionAmount(partnerId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/dashboard/commissionEarned/styles.ts

function commissionEarned_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 10px 0;\n    background: linear-gradient(161.3deg, #fff7e5 -2.04%, #fbe9f6 102.81%);\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n"
    ]);
    commissionEarned_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function commissionEarned_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 5px;\n"
    ]);
    commissionEarned_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function commissionEarned_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 20px;\n    height: 20px;\n"
    ]);
    commissionEarned_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function commissionEarned_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    margin-left: 15px;\n"
    ]);
    commissionEarned_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function commissionEarned_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    color: #000000;\n    margin: 4px;\n"
    ]);
    commissionEarned_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var commissionEarned_styles_Wrapper = styled_components_browser_esm["default"].div(commissionEarned_styles_templateObject());
var IconWrapper = styled_components_browser_esm["default"].div(commissionEarned_styles_templateObject1());
var LoaderWrapper = styled_components_browser_esm["default"].div(commissionEarned_styles_templateObject2());
var TextBoxWrapper = styled_components_browser_esm["default"].div(commissionEarned_styles_templateObject3());
var styles_Text = styled_components_browser_esm["default"].h2(commissionEarned_styles_templateObject4());

;// CONCATENATED MODULE: ./components/dashboard/commissionEarned/index.tsx





// hooks


// context

// utils




var CommissionEarned = function(props) {
    var partner = props.partner;
    var partnerId = (0,compat_module.useContext)(context/* MPosContext */.w).partnerId;
    var ref = (0,compat_module.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,compat_module.useState)(0), amount = ref1[0], setAmount = ref1[1];
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var getAmount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getCommissionAmount(partner)
                        ];
                    case 1:
                        response = _state.sent();
                        setAmount(response.amount);
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function getAmount() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,compat_module.useEffect)(function() {
        getAmount();
    }, []);
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_COMMISSIONS_EARNED_V1_PAGE */.g0.VIEW_COMMISSIONS_EARNED_V1_PAGE,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(commissionEarned_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: (0,generics/* getImageBasePath */.m4)("/icons/wallet.svg"),
                    alt: "",
                    width: "32px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TextBoxWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Text, {
                        children: "Today's Earnings"
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LoaderWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: (0,generics/* getImageBasePath */.m4)("/gif/greenCircleLoader.gif"),
                            alt: "...",
                            width: "20px",
                            height: "20px"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Text, {
                        children: [
                            "Rs. ",
                            amount
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var commissionEarned = (CommissionEarned);

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.dropdown/dist/index.js
var building_blocks_ui_dropdown_dist = __webpack_require__(9657);
;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/transactionItemCardV2/styles.ts

function transactionItemCardV2_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 10px;\n"
    ]);
    transactionItemCardV2_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 9;\n    flex-direction: column;\n"
    ]);
    transactionItemCardV2_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    align-items: center;\n"
    ]);
    transactionItemCardV2_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n"
    ]);
    transactionItemCardV2_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    transactionItemCardV2_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n    ",
        "\n"
    ]);
    transactionItemCardV2_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    margin-top: 4px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    color: #5b5675;\n"
    ]);
    transactionItemCardV2_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    justify-content: flex-end;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    transactionItemCardV2_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function transactionItemCardV2_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n    background-color: ",
        ";\n    color: ",
        ";\n    padding: 2px 6px;\n    border-radius: 4px;\n"
    ]);
    transactionItemCardV2_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var transactionItemCardV2_styles_Wrapper = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject());
var styles_DivFlex = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject1());
var styles_RightArrowIconFlex = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject2());
var styles_RowFlex = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject3());
var styles_Value1 = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject4());
var styles_Value2 = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject5(), function(props) {
    return props.label && "font-weight: 400;\n        font-size: 14px;\n    ";
});
var styles_Value3 = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject6());
var styles_Value4 = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject7());
var styles_Value4BackgroundText = building_blocks_ui_common_dist.styled.div(transactionItemCardV2_styles_templateObject8(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});

;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/transactionItemCardV2/index.tsx




var TransactionItemCardV2 = function(props) {
    var value1 = props.value1, value2 = props.value2, value3 = props.value3, value4 = props.value4, labelColor = props.labelColor;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(transactionItemCardV2_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_DivFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value1, {
                                children: value1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value2, {
                                label: labelColor,
                                children: value2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value3, {
                                children: value3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value4, {
                                children: (labelColor === null || labelColor === void 0 ? void 0 : labelColor.background) ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Value4BackgroundText, {
                                    background: labelColor.background,
                                    color: labelColor.color,
                                    children: value4
                                }) : value4
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_RightArrowIconFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "12px",
                    height: "12px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/rightArrow.svg")
                })
            })
        ]
    });
};
/* harmony default export */ var transactionItemCardV2 = (TransactionItemCardV2);

;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/types.ts
var trasactionFilterTypes = [
    {
        value: "all",
        displayValue: "All"
    },
    {
        value: "pending",
        displayValue: "Pending"
    },
    {
        value: "completed",
        displayValue: "Completed"
    },
    {
        value: "failed",
        displayValue: "Failed"
    }, 
];
var types_TabOptions;
(function(TabOptions) {
    TabOptions["PENDING"] = "Pending";
    TabOptions["COMPLETED"] = "Completed";
})(types_TabOptions || (types_TabOptions = {}));

;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/styles.ts

function transactionsV2_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 32px;\n"
    ]);
    transactionsV2_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    transactionsV2_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #000000;\n"
    ]);
    transactionsV2_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n"
    ]);
    transactionsV2_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 12px;\n"
    ]);
    transactionsV2_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n"
    ]);
    transactionsV2_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n    margin-bottom: 8px;\n"
    ]);
    transactionsV2_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    transactionsV2_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function transactionsV2_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 6px 0;\n"
    ]);
    transactionsV2_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    height: 0;\n    border: 1px solid #e7e7f0;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var transactionsV2_styles_Wrapper = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject());
var TransactionBox = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject1());
var TrasactionList = building_blocks_ui_common_dist.styled.h2(transactionsV2_styles_templateObject2());
var TransactionDropDown = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject3(), function(param) {
    var $isHidden = param.$isHidden;
    return $isHidden && "display: none;";
});
var TransactionHeaderActions = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject4());
var SearchIcon = building_blocks_ui_common_dist.styled.img(transactionsV2_styles_templateObject5());
var SearchInputWrapper = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject6());
var styles_NoResult = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject7());
var styles_ItemCardWrapper = building_blocks_ui_common_dist.styled.div(transactionsV2_styles_templateObject8());
var transactionsV2_styles_Hr = building_blocks_ui_common_dist.styled.div(styles_templateObject9());

;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/transactionDetailModalV2/api.ts





var sendCustomerPolicyCommunication = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(policyNumber) {
        var status, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios/* default */.Z)((0,_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/").concat(policyNumber, "/send-communication")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    status = _state.sent().status;
                    if (status === 200) {
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendCustomerPolicyCommunication(policyNumber) {
        return _ref.apply(this, arguments);
    };
}();
var cancelOrderApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId, orderEkey) {
        var status, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios/* default */.Z)((0,_object_spread/* default */.Z)({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/order/").concat(orderEkey, "/cancel")
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    status = _state.sent().status;
                    if (status === 200) {
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function cancelOrderApi(partnerId, orderEkey) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/transactionDetailModalV2/styles.ts

function transactionDetailModalV2_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n"
    ]);
    transactionDetailModalV2_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    transactionDetailModalV2_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 14px;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 20px;\n    padding: 6px;\n    width: fit-content;\n"
    ]);
    transactionDetailModalV2_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n    background: none;\n    color: #007bff;\n    cursor: pointer;\n    font-size: 18px;\n    margin-left: auto;\n    margin-top: 10px;\n\n    &:disabled {\n        color: #666;\n        cursor: not-allowed;\n        opacity: 0.6;\n    }\n"
    ]);
    transactionDetailModalV2_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #007bff;\n    text-decoration: none;\n"
    ]);
    transactionDetailModalV2_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n"
    ]);
    transactionDetailModalV2_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n    margin-top: 4px;\n"
    ]);
    transactionDetailModalV2_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 14px;\n    background: ",
        ";\n    border-radius: 4px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: ",
        ";\n    padding: 6px;\n    width: fit-content;\n"
    ]);
    transactionDetailModalV2_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    padding: 12px;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 12px;\n    margin-top: 26px;\n    border: 1px solid #e7e7f0;\n    box-sizing: border-box;\n"
    ]);
    transactionDetailModalV2_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function transactionDetailModalV2_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 10px;\n    align-items: flex-start;\n    gap: 12px;\n"
    ]);
    transactionDetailModalV2_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    min-width: 0;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    min-width: 0;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n    text-align: end;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0px;\n    opacity: 0.1;\n    border: 1px solid #040222;\n    margin-top: 10px;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 24px;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    flex-direction: column;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 6px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #040222;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 1;\n    align-items: flex-end;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 16px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    margin-top: 12px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #1b73e8;\n    justify-content: center;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}

var transactionDetailModalV2_styles_Wrapper = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject());
var StatusWrapper = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject1());
var InvoiceWrapper = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject2());
var SendCommunicationButton = building_blocks_ui_common_dist.styled.button(transactionDetailModalV2_styles_templateObject3());
var InvoiceUrl = building_blocks_ui_common_dist.styled.a(transactionDetailModalV2_styles_templateObject4());
var styles_ModalName = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject5());
var styles_LastUpdatedDate = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject6());
var styles_StatusText = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject7(), function(props) {
    return props.background;
}, function(props) {
    return props.color;
});
var styles_PlanDetailsWrapper = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject8());
var styles_RowWrapper = building_blocks_ui_common_dist.styled.div(transactionDetailModalV2_styles_templateObject9());
var styles_LabelText = building_blocks_ui_common_dist.styled.div(styles_templateObject10());
var styles_ValueText = building_blocks_ui_common_dist.styled.div(styles_templateObject11());
var transactionDetailModalV2_styles_Hr = building_blocks_ui_common_dist.styled.div(styles_templateObject12());
var styles_CustomerDetailsWrapper = building_blocks_ui_common_dist.styled.div(styles_templateObject13());
var styles_CustomerMobileFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject14());
var styles_CustomerMobileText = building_blocks_ui_common_dist.styled.div(styles_templateObject15());
var styles_CustomerMobileNumber = building_blocks_ui_common_dist.styled.div(_templateObject16());
var styles_CustomerAmountFlex = (0,building_blocks_ui_common_dist.styled)(styles_CustomerMobileFlex)(_templateObject17());
var styles_ResendLinkWrapper = building_blocks_ui_common_dist.styled.div(_templateObject18());
var CancelOrderWrapper = building_blocks_ui_common_dist.styled.div(_templateObject19());
var styles_ResendLinkText = building_blocks_ui_common_dist.styled.div(_templateObject20());

// EXTERNAL MODULE: ./components/orderSummary/apis.ts
var apis = __webpack_require__(4477);
// EXTERNAL MODULE: ./components/orderSummary/types.ts
var types = __webpack_require__(9985);
// EXTERNAL MODULE: ./utils/segment/index.ts
var segment = __webpack_require__(2199);
;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/transactionDetailModalV2/index.tsx











// utils








// events



var TransactionDetailsModalV2 = function(props) {
    var deviceName = props.deviceName, lastUpdatedAt = props.lastUpdatedAt, status = props.status, statusMessage = props.statusMessage, serialNumber = props.serialNumber, planName = props.planName, coverage = props.coverage, mobileNumber = props.mobileNumber, amount = props.amount, deviceCategory = props.deviceCategory, onClick = props.onClick, isBtnLoading = props.isBtnLoading, vin = props.vin, invoice_url = props.invoice_url, policyNumber = props.policyNumber, policyEKey = props.policyEKey, paymentPaidBy = props.paymentPaidBy, orderEKey = props.orderEKey;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var ref = (0,compat_module.useState)(false), isCommunicationProcessing = ref[0], setIsCommunicationProcession = ref[1];
    var ref1 = (0,compat_module.useState)(false), isOrderCancelling = ref1[0], setIsOrderCancelling = ref1[1];
    var ref2 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref2[0], setSnackbar = ref2[1];
    var ref3 = (0,compat_module.useState)([]), paymentOptions = ref3[0], setPaymentOptions = ref3[1];
    var ref4 = (0,compat_module.useContext)(context/* MPosContext */.w), permissionsMap = ref4.permissionsMap, userDetails = ref4.userDetails, partnerId = ref4.partnerId, permissions = ref4.permissions;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var router = (0,next_router.useRouter)();
    var getColors = function() {
        switch(status){
            case OrderStatus.ORDER_CREATED:
            case OrderStatus.PAYMENT_INITIATED_BY_CUSTOMER:
            case OrderStatus.PAYMENT_INITIATED_BY_DEALER:
            case OrderStatus.PAYMENT_SUCCESS_BY_CUSTOMER:
            case OrderStatus.PAYMENT_SUCCESS_BY_DEALER:
                return {
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            case OrderStatus.POLICY_CREATED:
                return {
                    background: "#99fc9d",
                    color: "#0c843f"
                };
            default:
                return {
                    color: "#D83D37",
                    background: "#FBEAEA"
                };
        }
    };
    var ref5 = getColors(), background = ref5.background, color = ref5.color;
    var sendCommunicationHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var isSent, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!policyNumber) return [
                            3,
                            5
                        ];
                        setIsCommunicationProcession(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            sendCustomerPolicyCommunication(policyNumber)
                        ];
                    case 2:
                        isSent = _state.sent();
                        if (isSent) {
                            setSnackbar({
                                message: "Communication Sent Successfully",
                                type: "success"
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setSnackbar({
                            message: "Failed to Send Communication",
                            type: "failure"
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsCommunicationProcession(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendCommunicationHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelOrderHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsOrderCancelling(true);
                        return [
                            4,
                            onClick("cancel")
                        ];
                    case 1:
                        _state.sent();
                        setIsOrderCancelling(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function cancelOrderHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var customerPDFUrl = "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/policy/pdf?pid=").concat(policyEKey);
    (0,compat_module.useEffect)(function() {
        var fetchPaymentOptions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, status, data, statusCode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,apis.getAllPaymentOptions)(partnerId, permissions.group)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data, statusCode = ref.statusCode;
                            if (statusCode === 401) {
                                router.push("/login");
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page."
                                });
                                return [
                                    2
                                ];
                            }
                            if (status) {
                                setPaymentOptions(data || []);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPaymentOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPaymentOptions();
        if (true) {
            (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
                page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
                view_name: constants/* SegmentEventPages.VIEW_TRANSACTION_DETAIL_MODAL */.g0.VIEW_TRANSACTION_DETAIL_MODAL
            }, {
                userDetails: userDetails,
                isMobile: isMobile
            });
        }
    }, [
        window,
        partnerId
    ]);
    var onResendLinkClick = function() {
        onClick("resend");
        // segment Events
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_name: constants/* SegmentEventActionNames.CLICK_RESEND_LINK_BUTTON */.iV.CLICK_RESEND_LINK_BUTTON,
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var onPayClick = function() {
        var isDealerWalletPaymentApplicable = paymentOptions.some(function(option) {
            return (option === null || option === void 0 ? void 0 : option.type) === types/* PaymentOptionType.DEALER_WALLET_PAYMENT */.G.DEALER_WALLET_PAYMENT && (option === null || option === void 0 ? void 0 : option.applicable) === true;
        });
        if (isDealerWalletPaymentApplicable && partnerId) {
            router.push("/".concat(lob, "/").concat(partnerId, "/payment-mode?order_ekey=").concat(orderEKey));
            return;
        }
        onClick("pay");
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(transactionDetailModalV2_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ModalName, {
                children: deviceName
            }),
            status === OrderStatus.POLICY_CREATED ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_LastUpdatedDate, {
                children: [
                    "Policy Issued On ",
                    lastUpdatedAt
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_LastUpdatedDate, {
                children: [
                    "Last updated ",
                    lastUpdatedAt
                ]
            }),
            status === OrderStatus.POLICY_CREATED && (paymentPaidBy === null || paymentPaidBy === void 0 ? void 0 : paymentPaidBy.toLowerCase()) === "customer" && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StatusWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_StatusText, {
                    background: background,
                    color: color,
                    children: "Paid by customer"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(StatusWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_StatusText, {
                        background: background,
                        color: color,
                        children: statusMessage || status
                    }),
                    status === OrderStatus.POLICY_CREATED && permissionsMap[utils_constants/* Permissions.GST_INVOICE */.Pl.GST_INVOICE] && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InvoiceWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InvoiceUrl, {
                            href: invoice_url,
                            target: "_blank",
                            children: "Download B2B Invoice"
                        })
                    }),
                    status === OrderStatus.POLICY_CREATED && policyEKey && permissionsMap[utils_constants/* Permissions.CUSTOMER_PDF */.Pl.CUSTOMER_PDF] && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InvoiceWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InvoiceUrl, {
                            href: customerPDFUrl,
                            target: "_blank",
                            children: "Customer PDF"
                        })
                    })
                ]
            }),
            status === OrderStatus.POLICY_CREATED && policyNumber && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(StatusWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SendCommunicationButton, {
                    onClick: sendCommunicationHandler,
                    disabled: isCommunicationProcessing,
                    children: "Send Customer Communication"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_PlanDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                children: "Device model"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                children: deviceName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionDetailModalV2_styles_Hr, {}),
                    lob === utils_constants/* LOB.EMBEDDED */.r6.EMBEDDED && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: deviceCategory === newPlan_constants/* DeviceCategory.MOBILE */.I_.MOBILE || deviceCategory === newPlan_constants/* DeviceCategory.TABLET */.I_.TABLET ? "IMEI" : "Serial Number"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: serialNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionDetailModalV2_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "Plan Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: planName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionDetailModalV2_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "What’s covered"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: coverage
                                    })
                                ]
                            }),
                            " "
                        ]
                    }),
                    lob === utils_constants/* LOB.AUTO */.r6.AUTO && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "VIN"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: vin
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionDetailModalV2_styles_Hr, {}),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_LabelText, {
                                        children: "Plan Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ValueText, {
                                        children: planName
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CustomerDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CustomerMobileFlex, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CustomerMobileText, {
                                children: "Customer mobile number"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CustomerMobileNumber, {
                                children: mobileNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CustomerAmountFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CustomerMobileFlex, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_CustomerMobileText, {
                                    children: "Amount"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CustomerMobileNumber, {
                                    children: [
                                        "₹",
                                        amount
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (status === OrderStatus.ORDER_CREATED || status === OrderStatus.PAYMENT_INITIATED_BY_DEALER || status === OrderStatus.PAYMENT_FAILED) && paymentOptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ResendLinkWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isBtnLoading,
                    isFullWidth: true,
                    size: "medium",
                    onClick: onPayClick,
                    children: "Pay Acko"
                })
            }),
            isDealerCancellableOrderStatus(status) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ResendLinkWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.SecondaryButton, {
                    loading: isOrderCancelling,
                    isFullWidth: true,
                    size: "medium",
                    onClick: cancelOrderHandler,
                    children: "Cancel Order"
                })
            }),
            (status === OrderStatus.CUSTOMER_LINK_SHARED || status === OrderStatus.PAYMENT_INITIATED_BY_CUSTOMER) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_ResendLinkWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_button_dist.PrimaryButton, {
                    loading: isBtnLoading,
                    isFullWidth: true,
                    size: "medium",
                    onClick: onResendLinkClick,
                    children: "Resend Link"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var transactionDetailModalV2 = (TransactionDetailsModalV2);

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.search-input/dist/index.js
var building_blocks_ui_search_input_dist = __webpack_require__(8210);
var building_blocks_ui_search_input_dist_default = /*#__PURE__*/__webpack_require__.n(building_blocks_ui_search_input_dist);
;// CONCATENATED MODULE: ./components/dashboard/transactionsV2/index.tsx





















// segment




var TransactionsV2 = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var orders = props.orders, hasMore = props.hasMore, onLoadMore = props.onLoadMore, refresh = props.refresh, searchValue = props.searchValue, onSearchChange = props.onSearchChange, clearSearch = props.clearSearch;
    var ref7 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref7.partnerId, userDetails = ref7.userDetails;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var ref8 = (0,compat_module.useState)(false), isSearchOpen = ref8[0], setIsSearchOpen = ref8[1];
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref9 = (0,compat_module.useState)(false), modalStatus = ref9[0], setModalStatus = ref9[1];
    var ref10 = (0,compat_module.useState)(null), selectedOrder = ref10[0], setSelectedOrder = ref10[1];
    var ref11 = (0,compat_module.useState)(false), isBtnLoading = ref11[0], setIsBtnLoading = ref11[1];
    var ref12 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref12[0], setSnackbar = ref12[1];
    var ref13 = (0,compat_module.useState)({
        displayValue: "All",
        value: "all"
    }), type = ref13[0], setType = ref13[1];
    var ref14 = (0,compat_module.useState)(false), triggered = ref14[0], setTriggered = ref14[1];
    var filterTypeChangeHandler = function(param) {
        var value = param.value, displayValue = param.displayValue;
        setType(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                value: value,
                displayValue: displayValue
            });
        });
        // segment Events
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_name: "select_".concat(displayValue, "_transacions"),
            button_name: constants/* SegmentEventButtonNames.SELECT_TRANSACTIONS_TYPE */.A3.SELECT_TRANSACTIONS_TYPE,
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            field_selected: constants/* SegmentEventFieldTypes.DROPDOWN */.OX.DROPDOWN
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    (0,compat_module.useEffect)(function() {
        var dropdownElements = document.getElementsByClassName("dropwdownWidth");
        if (dropdownElements && dropdownElements.length > 0) {
            var dropdownElement = dropdownElements[0];
            dropdownElement.style.minWidth = "150px";
        }
    }, []);
    (0,compat_module.useEffect)(function() {
        if (triggered) {
            onLoadMore(type.value);
        } else {
            setTriggered(true);
        }
    }, [
        type
    ]);
    var orderStatus = function(status, statusMessage) {
        switch(status){
            case OrderStatus.ORDER_CREATED:
            case OrderStatus.PAYMENT_INITIATED_BY_DEALER:
            case OrderStatus.PAYMENT_INITIATED_BY_CUSTOMER:
                return {
                    text: "PENDING",
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            case OrderStatus.PAYMENT_SUCCESS_BY_DEALER:
            case OrderStatus.PAYMENT_SUCCESS_BY_CUSTOMER:
                return {
                    text: "POLICY ISSUANCE PENDING",
                    color: "#5920C5",
                    background: "#EFE9FB"
                };
            case OrderStatus.POLICY_CREATED:
                return {
                    text: "COMPLETED",
                    background: "#99fc9d",
                    color: "#0c843f"
                };
            default:
                return {
                    text: statusMessage.toUpperCase(),
                    color: "#D83D37",
                    background: "#FBEAEA"
                };
        }
    };
    var getValueObjects = function(order) {
        var ref = orderStatus(order.status, order.status_message), text = ref.text, color = ref.color, background = ref.background;
        var value2 = order.status === OrderStatus.POLICY_CREATED ? (order === null || order === void 0 ? void 0 : order.policy_issued_on) ? (0,date/* getDD_Month_Time */.Se)(new Date(order.policy_issued_on)) : (0,date/* getDD_Month_Time */.Se)(new Date(order.updated_on)) : (0,date/* getDD_Month_Time */.Se)(new Date(order.updated_on));
        return {
            value1: order.device.name,
            value2: value2,
            value3: order.customer.phone,
            value4: text,
            labelColor: {
                color: color,
                background: background
            }
        };
        // if (type.value === TabOptions.PENDING) {
        //     const { text, color, background } = orderStatus(
        //         order.status,
        //         order.status_message
        //     );
        //     return {
        //         value1: order.device.name,
        //         value2: getDD_Month_Time(new Date(order.updated_on)),
        //         value3: order.customer.phone,
        //         value4: text,
        //         labelColor: {
        //             color,
        //             background,
        //         },
        //     };
        // }
        return {
            value1: order.customer.name,
            value2: "₹".concat(order.plan.premium),
            value3: order.device.name,
            value4: order.device.purchase_date
        };
    };
    var onClickOrder = function(order) {
        setModalStatus(true);
        setSelectedOrder(order);
        // segment Events
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_name: constants/* SegmentEventActionNames.CLICK_TRANSACTION_ITEM */.iV.CLICK_TRANSACTION_ITEM,
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var onHideTransactionDetailsModal = function() {
        setModalStatus(false);
        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_name: constants/* SegmentEventActionNames.CLOSE_TRANSACTION_DETAILS_MODAL */.iV.CLOSE_TRANSACTION_DETAILS_MODAL,
            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    var onClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(action) {
            var ref, isSent, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selectedOrder) return [
                            3,
                            8
                        ];
                        if (!(action === "pay")) return [
                            3,
                            1
                        ];
                        if ((ref = selectedOrder.payment_details) === null || ref === void 0 ? void 0 : ref.wallet_enabled) {
                            router.push("/".concat(lob, "/").concat(partnerId, "/payment-mode?order_ekey=").concat(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.ekey));
                        } else {
                            setIsBtnLoading(true);
                            __webpack_require__.e(/* import() */ 146).then(__webpack_require__.bind(__webpack_require__, 442)).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                                    var ref, data, status, statusCode;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    req.dealerPayment(partnerId, selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.ekey)
                                                ];
                                            case 1:
                                                ref = _state.sent(), data = ref.data, status = ref.status, statusCode = ref.statusCode;
                                                setIsBtnLoading(false);
                                                if (statusCode === 401) {
                                                    router.push("/login");
                                                    setSnackbar({
                                                        type: "failure",
                                                        message: "Token expired. Redirecting to login page."
                                                    });
                                                    return [
                                                        2
                                                    ];
                                                }
                                                if (status && data) {
                                                    if (status && (data === null || data === void 0 ? void 0 : data.payment_gateway_url)) {
                                                        window.location.href = "".concat(data.payment_gateway_url, "?id=").concat(data === null || data === void 0 ? void 0 : data.payment_order_ekey, "&redirect_source=pos_dealer");
                                                    }
                                                    return [
                                                        2
                                                    ];
                                                }
                                                setSnackbar({
                                                    type: "failure",
                                                    message: "Oops. Something went wrong."
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(req) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        }
                        return [
                            3,
                            7
                        ];
                    case 1:
                        if (!(action === "resend")) return [
                            3,
                            2
                        ];
                        __webpack_require__.e(/* import() */ 146).then(__webpack_require__.bind(__webpack_require__, 442)).then(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                                var ref, status, statusCode, errorMessage;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            setIsBtnLoading(true);
                                            return [
                                                4,
                                                req.resendLinkToCustomer(partnerId, (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.ekey) || "")
                                            ];
                                        case 1:
                                            ref = _state.sent(), status = ref.status, statusCode = ref.statusCode, errorMessage = ref.errorMessage;
                                            if (statusCode === 401) {
                                                router.push("/login");
                                                setSnackbar({
                                                    type: "failure",
                                                    message: "Token expired. Redirecting to login page."
                                                });
                                                return [
                                                    2
                                                ];
                                            }
                                            setIsBtnLoading(false);
                                            if (status) {
                                                setSnackbar({
                                                    type: "success",
                                                    message: "Payment link has sent successfully."
                                                });
                                                return [
                                                    2
                                                ];
                                            }
                                            setSnackbar({
                                                type: "failure",
                                                message: errorMessage || "Oops. Something went wrong."
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(req) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            3,
                            7
                        ];
                    case 2:
                        if (!(action === "cancel")) return [
                            3,
                            7
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            6,
                            7
                        ]);
                        return [
                            4,
                            cancelOrderApi(partnerId, selectedOrder.ekey)
                        ];
                    case 4:
                        isSent = _state.sent();
                        if (isSent) {
                            setSnackbar({
                                message: "Order Cancelled Successfully",
                                type: "success"
                            });
                        }
                        setModalStatus(false);
                        refresh();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        e = _state.sent();
                        setSnackbar({
                            message: "Failed to cancel order",
                            type: "failure"
                        });
                        return [
                            3,
                            7
                        ];
                    case 6:
                        return [
                            7
                        ];
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setSnackbar({
                            type: "failure",
                            message: "No order selected."
                        });
                        _state.label = 9;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClick(action) {
            return _ref.apply(this, arguments);
        };
    }();
    var Modal = isMobile ? dist.ModalMobile : dist.ModalDesktop;
    // ModalMobile doesn't read these props, but keep them desktop-only so
    // the mobile bottom sheet stays intentionally full-width and isn't
    // coupled to a desktop-only layout constant.
    var desktopModalWidthProps = isMobile ? {} : {
        maxWidth: "560px",
        minimumWidth: "560px"
    };
    var searchPlaceholder = lob === "auto-lob" ? "Search by customer phone or vin" : "Search by customer phone or serial number";
    var toggleSearch = function() {
        if (isSearchOpen) {
            if (searchValue) {
                clearSearch();
            }
            setIsSearchOpen(false);
        } else {
            setIsSearchOpen(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(transactionsV2_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TransactionBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TrasactionList, {
                        children: "Transactions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TransactionHeaderActions, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SearchIcon, {
                                src: isSearchOpen ? (0,generics/* getImageBasePath */.m4)("/icons/cross.svg") : (0,generics/* getImageBasePath */.m4)("/icons/search.svg"),
                                alt: isSearchOpen ? "close" : "search",
                                onClick: toggleSearch
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TransactionDropDown, {
                                $isHidden: isSearchOpen,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(building_blocks_ui_dropdown_dist/* Dropdown */.Lt, {
                                    className: "dropwdownWidth",
                                    label: "filter",
                                    value: type,
                                    options: trasactionFilterTypes,
                                    onChange: filterTypeChangeHandler
                                })
                            })
                        ]
                    })
                ]
            }),
            isSearchOpen && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SearchInputWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((building_blocks_ui_search_input_dist_default()), {
                    className: "",
                    placeholder: searchPlaceholder,
                    handleChange: function(value) {
                        return onSearchChange(value);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                children: orders.length === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_NoResult, {
                    children: "No Transactions"
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                    dataLength: orders.length,
                    next: function() {
                        return onLoadMore(type.value);
                    },
                    hasMore: hasMore,
                    loader: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                    children: orders.map(function(order, index) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_ItemCardWrapper, {
                            onClick: function() {
                                return onClickOrder(order);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionItemCardV2, (0,_object_spread/* default */.Z)({}, getValueObjects(order))),
                                index !== orders.length - 1 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionsV2_styles_Hr, {})
                            ]
                        }, order.ekey);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: modalStatus,
                onHide: onHideTransactionDetailsModal,
                padding: "20px"
            }, desktopModalWidthProps), {
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: selectedOrder && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionDetailModalV2, {
                    deviceName: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref = selectedOrder.device) === null || ref === void 0 ? void 0 : ref.name,
                    invoice_url: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.plan.invoice_url,
                    lastUpdatedAt: selectedOrder.status === OrderStatus.POLICY_CREATED ? (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.policy_issued_on) ? (0,date/* getDD_MM_YYYY */.PZ)(new Date(selectedOrder.policy_issued_on)) : (0,date/* getDD_MM_YYYY */.PZ)(new Date(selectedOrder.updated_on)) : (0,date/* getDD_MM_YYYY */.PZ)(new Date(selectedOrder.updated_on)),
                    status: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.status,
                    statusMessage: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.status_message,
                    serialNumber: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref1 = selectedOrder.device) === null || ref1 === void 0 ? void 0 : ref1.serial_number,
                    planName: (0,generics/* getPlanName */.s0)(selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.plan.plan_name),
                    mobileNumber: selectedOrder.customer.phone,
                    amount: selectedOrder.plan.settle_with_acko,
                    deviceCategory: selectedOrder.device.category,
                    coverage: (0,generics/* whatsCoverText */.oX)((ref2 = selectedOrder.plan.plan_category) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()),
                    onClick: onClick,
                    isBtnLoading: isBtnLoading,
                    vin: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref3 = selectedOrder.device) === null || ref3 === void 0 ? void 0 : ref3.vin,
                    policyNumber: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref4 = selectedOrder.policy_details) === null || ref4 === void 0 ? void 0 : ref4.policy_number,
                    policyEKey: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref5 = selectedOrder.policy_details) === null || ref5 === void 0 ? void 0 : ref5.contract_id,
                    paymentPaidBy: selectedOrder === null || selectedOrder === void 0 ? void 0 : (ref6 = selectedOrder.payment_details) === null || ref6 === void 0 ? void 0 : ref6.user_type,
                    orderEKey: selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.ekey
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
};
/* harmony default export */ var transactionsV2 = (TransactionsV2);

// EXTERNAL MODULE: ./components/dashboard/apis.ts
var dashboard_apis = __webpack_require__(9231);
// EXTERNAL MODULE: ./components/dashboard/gstDetailsUpdateModal/index.tsx + 1 modules
var gstDetailsUpdateModal = __webpack_require__(1716);
;// CONCATENATED MODULE: ./components/dashboard/index.tsx
























function Dashboard() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref.partnerId, legalDetailsUploadedStatus = ref.legalDetailsUploadedStatus, setPlanDetails = ref.setPlanDetails, setActiveStage = ref.setActiveStage, permissions = ref.permissions, gstDetailsValid = ref.gstDetailsValid, userDetails = ref.userDetails;
    var purchase_journey = permissions.purchase_journey;
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref1 = (0,compat_module.useState)([]), pendingOrders = ref1[0], setPendingOrders = ref1[1];
    var ref2 = (0,compat_module.useState)([]), completedOrders = ref2[0], setCompletedOrders = ref2[1];
    var ref3 = (0,compat_module.useState)([]), orderList = ref3[0], setOrderList = ref3[1];
    var ref4 = (0,compat_module.useState)(0), pendingOrdersPage = ref4[0], setPendingOrdersPage = ref4[1];
    var ref5 = (0,compat_module.useState)(0), completedOrdersPage = ref5[0], setCompletedOrdersPage = ref5[1];
    var ref6 = (0,compat_module.useState)(0), ordersPage = ref6[0], setOrdersPage = ref6[1];
    var ref7 = (0,compat_module.useState)({
        pending: true,
        completed: true,
        orders: true
    }), hasMore = ref7[0], setHasMore = ref7[1];
    var ref8 = (0,compat_module.useState)(true), isPageLoading = ref8[0], setIsPageLoading = ref8[1];
    var ref9 = (0,compat_module.useState)(""), errorMesssage = ref9[0], setErrorMessage = ref9[1];
    var ref10 = (0,compat_module.useState)("all"), tabSelected = ref10[0], setTabSelected = ref10[1];
    var ref11 = (0,compat_module.useState)(""), searchValue = ref11[0], setSearchValue = ref11[1];
    var prevSearchValue = (0,compat_module.useRef)("");
    (0,compat_module.useEffect)(function() {
        /**
         * view segment hook
         */ (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            view_name: constants/* SegmentEventPages.VIEW_HOMEPAGE_DEALER */.g0.VIEW_HOMEPAGE_DEALER,
            page_type: constants/* SegmentEventPages.VIEW_MAIN_PAGE */.g0.VIEW_MAIN_PAGE
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
        setPlanDetails(newPlan_constants/* policyDetailsInitState */.c8);
        setActiveStage(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL);
    }, []);
    (0,compat_module.useEffect)(function() {
        if (!partnerId || !permissions.group) {
            return;
        }
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9231)).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                var ref, status, data, _recent_orders, pending_orders, completed_orders, orders;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getDealerDashboard(partnerId, permissions.group, 0, "", purchase_journey, searchValue)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                                _recent_orders = data.recent_orders, pending_orders = _recent_orders.pending_orders, completed_orders = _recent_orders.completed_orders, orders = _recent_orders.orders;
                                setPendingOrders(pending_orders || []);
                                setCompletedOrders(completed_orders || []);
                                setOrderList(orders || []);
                                if ((pending_orders === null || pending_orders === void 0 ? void 0 : pending_orders.length) > 9) {
                                    setPendingOrdersPage(1);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                        pending: false
                                    }));
                                }
                                if ((completed_orders === null || completed_orders === void 0 ? void 0 : completed_orders.length) > 9) {
                                    setCompletedOrdersPage(1);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                        completed: false
                                    }));
                                }
                                if ((orders === null || orders === void 0 ? void 0 : orders.length) > 9) {
                                    setOrdersPage(1);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                        orders: false
                                    }));
                                }
                                setErrorMessage("");
                            } else {
                                setErrorMessage("Something went wrong.");
                            }
                            setIsPageLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        partnerId,
        permissions.group
    ]);
    (0,compat_module.useEffect)(function() {
        if (prevSearchValue.current === searchValue) {
            return;
        }
        prevSearchValue.current = searchValue;
        var timeout;
        if (partnerId && permissions.group) {
            timeout = setTimeout(function() {
                setHasMore(function(prev) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                        orders: true
                    });
                });
                setOrdersPage(0);
                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9231)).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                        var ref, status, data, orders;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        req.getDealerDashboard(partnerId, permissions.group, 0, tabSelected === "all" ? "" : tabSelected, purchase_journey, searchValue)
                                    ];
                                case 1:
                                    ref = _state.sent(), status = ref.status, data = ref.data;
                                    if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                                        orders = data.recent_orders.orders;
                                        setOrderList(orders || []);
                                        if ((orders === null || orders === void 0 ? void 0 : orders.length) > 9) {
                                            setOrdersPage(1);
                                            setHasMore(function(prev) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                    orders: true
                                                });
                                            });
                                        } else {
                                            setHasMore(function(prev) {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                    orders: false
                                                });
                                            });
                                        }
                                        setErrorMessage("");
                                    } else {
                                        setErrorMessage("Something went wrong.");
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }, 500);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchValue,
        partnerId,
        permissions.group,
        tabSelected,
        purchase_journey, 
    ]);
    var clearSearch = function() {
        setSearchValue("");
        prevSearchValue.current = "";
        if (partnerId && permissions.group) {
            setHasMore(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    orders: true
                });
            });
            setOrdersPage(0);
            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9231)).then(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                    var ref, status, data, orders;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    req.getDealerDashboard(partnerId, permissions.group, 0, tabSelected === "all" ? "" : tabSelected, purchase_journey, "")
                                ];
                            case 1:
                                ref = _state.sent(), status = ref.status, data = ref.data;
                                if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                                    orders = data.recent_orders.orders;
                                    setOrderList(orders || []);
                                    if ((orders === null || orders === void 0 ? void 0 : orders.length) > 9) {
                                        setOrdersPage(1);
                                        setHasMore(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                orders: true
                                            });
                                        });
                                    } else {
                                        setHasMore(function(prev) {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                                orders: false
                                            });
                                        });
                                    }
                                    setErrorMessage("");
                                } else {
                                    setErrorMessage("Something went wrong.");
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(req) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    };
    var refreshDashbord = function() {
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9231)).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                var ref, status, data, _recent_orders, pending_orders, completed_orders, orders;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.getDealerDashboard(partnerId, permissions.group, 0, "", purchase_journey, searchValue)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, data = ref.data;
                            if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                                _recent_orders = data.recent_orders, pending_orders = _recent_orders.pending_orders, completed_orders = _recent_orders.completed_orders, orders = _recent_orders.orders;
                                setPendingOrders(pending_orders || []);
                                setCompletedOrders(completed_orders || []);
                                setOrderList(orders || []);
                                if ((pending_orders === null || pending_orders === void 0 ? void 0 : pending_orders.length) > 9) {
                                    setPendingOrdersPage(1);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                        pending: false
                                    }));
                                }
                                if ((completed_orders === null || completed_orders === void 0 ? void 0 : completed_orders.length) > 9) {
                                    setCompletedOrdersPage(1);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                        completed: false
                                    }));
                                }
                                if ((orders === null || orders === void 0 ? void 0 : orders.length) > 9) {
                                    setOrdersPage(1);
                                } else {
                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                        orders: false
                                    }));
                                }
                                setErrorMessage("");
                            } else {
                                setErrorMessage("Something went wrong.");
                            }
                            setIsPageLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var onLoadMoreV2 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selectedTab) {
            var ref, status, data, orders;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(selectedTab !== tabSelected)) return [
                            3,
                            1
                        ];
                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9231)).then(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                                var ref, status, data, orders;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                req.getDealerDashboard(partnerId, permissions.group, 0, selectedTab === "all" ? "" : selectedTab, purchase_journey, searchValue)
                                            ];
                                        case 1:
                                            ref = _state.sent(), status = ref.status, data = ref.data;
                                            if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                                                orders = data.recent_orders.orders;
                                                setOrderList(orders);
                                                if ((orders === null || orders === void 0 ? void 0 : orders.length) > 9) {
                                                    setOrdersPage(1);
                                                } else {
                                                    setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                                        orders: false
                                                    }));
                                                }
                                                setErrorMessage("");
                                            } else {
                                                setErrorMessage("Something went wrong.");
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(req) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        setTabSelected(selectedTab);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            (0,dashboard_apis.getDealerDashboard)(partnerId, permissions.group, ordersPage, selectedTab === "all" ? "" : selectedTab, purchase_journey, searchValue)
                        ];
                    case 2:
                        ref = _state.sent(), status = ref.status, data = ref.data;
                        if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                            orders = data.recent_orders.orders;
                            if ((orders === null || orders === void 0 ? void 0 : orders.length) > 0) {
                                setOrderList(orderList.concat(orders));
                                setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                    orders: orders.length > 9
                                }));
                                (orders === null || orders === void 0 ? void 0 : orders.length) > 9 && setOrdersPage(ordersPage + 1);
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onLoadMoreV2(selectedTab) {
            return _ref.apply(this, arguments);
        };
    }();
    var onLoadMore = function(selectedTab) {
        switch(purchase_journey){
            case "v1":
                onLoadMoreV2(selectedTab);
                return;
            default:
                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9231)).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                        var page, ref, status, data, _recent_orders, pending_orders, completed_orders;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    page = selectedTab === "pending" ? pendingOrdersPage : completedOrdersPage;
                                    return [
                                        4,
                                        req.getDealerDashboard(partnerId, permissions.group, page, selectedTab, purchase_journey)
                                    ];
                                case 1:
                                    ref = _state.sent(), status = ref.status, data = ref.data;
                                    if (status && (data === null || data === void 0 ? void 0 : data.recent_orders)) {
                                        _recent_orders = data.recent_orders, pending_orders = _recent_orders.pending_orders, completed_orders = _recent_orders.completed_orders;
                                        if (selectedTab === "pending") {
                                            if ((pending_orders === null || pending_orders === void 0 ? void 0 : pending_orders.length) > 0) {
                                                setPendingOrders(pendingOrders.concat(pending_orders));
                                                setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                                    pending: pending_orders.length > 9
                                                }));
                                                (pending_orders === null || pending_orders === void 0 ? void 0 : pending_orders.length) > 9 && setPendingOrdersPage(pendingOrdersPage + 1);
                                            } else {
                                                setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                                    pending: false
                                                }));
                                            }
                                            return [
                                                2
                                            ];
                                        }
                                        if ((completed_orders === null || completed_orders === void 0 ? void 0 : completed_orders.length) > 0) {
                                            setCompletedOrders(completedOrders.concat(completed_orders));
                                            setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                                completed: completed_orders.length > 9
                                            }));
                                            (completed_orders === null || completed_orders === void 0 ? void 0 : completed_orders.length) > 9 && setCompletedOrdersPage(completedOrdersPage + 1);
                                        } else {
                                            setHasMore((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hasMore), {
                                                completed: false
                                            }));
                                        }
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(req) {
                        return _ref.apply(this, arguments);
                    };
                }());
        }
    };
    var Modal = isMobile ? dist.ModalMobile : dist.ModalDesktop;
    if (isPageLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (errorMesssage) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dashboard_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Section, {
                                $index: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(newPlan, {})
                            }),
                            permissions.purchase_journey === "v1" && permissions.permission_list.length > 0 && permissions.permission_list.includes("commissions_earned") && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Section, {
                                $index: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(commissionEarned, {
                                    partner: partnerId
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Section, {
                                $index: 2,
                                children: purchase_journey === "v1" ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactionsV2, {
                                    hasMore: hasMore.orders,
                                    onLoadMore: onLoadMore,
                                    orders: orderList,
                                    refresh: refreshDashbord,
                                    searchValue: searchValue,
                                    onSearchChange: setSearchValue,
                                    clearSearch: clearSearch
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transactions, {
                                    pendingOrders: pendingOrders,
                                    completedOrders: completedOrders,
                                    hasMorePending: hasMore.pending,
                                    hasMoreCompleted: hasMore.completed,
                                    onLoadMore: onLoadMore
                                })
                            })
                        ]
                    })
                ]
            }),
            legalDetailsUploadedStatus && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                show: true,
                urlhash: "",
                onHide: function() {},
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                hideCloseButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(legalDocumentPending, {})
            }),
            !gstDetailsValid && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                show: true,
                urlhash: "",
                onHide: function() {},
                padding: "20px",
                maxWidth: "500px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                hideCloseButton: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(gstDetailsUpdateModal/* default */.Z, {})
            })
        ]
    });
}
/* harmony default export */ var dashboard = (Dashboard);


/***/ }),

/***/ 4477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dealerPayment": function() { return /* binding */ dealerPayment; },
/* harmony export */   "getAllPaymentOptions": function() { return /* binding */ getAllPaymentOptions; },
/* harmony export */   "getOrderByOrderEkey": function() { return /* binding */ getOrderByOrderEkey; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92);
/* harmony import */ var utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4733);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2729);





var getOrderByOrderEkey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(partnerId, order_ekey) {
        var ref, status, data, e, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partnerId, "/order"),
                            params: {
                                order_ekey: order_ekey,
                                user_type: "DEALER",
                                page: 0,
                                size: 1
                            }
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        return [
                            2,
                            {
                                status: true,
                                data: data
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                statusCode: 401,
                                status: false
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getOrderByOrderEkey(partnerId, order_ekey) {
        return _ref.apply(this, arguments);
    };
}();
var dealerPayment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(partnerId, order_ekey) {
        var ref, status, data, e, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "POST",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partnerId, "/payment"),
                            data: {
                                user_type: "dealer",
                                order_ekey: order_ekey
                            }
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        return [
                            2,
                            {
                                data: data,
                                status: true
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                statusCode: 401,
                                status: false
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function dealerPayment(partnerId, order_ekey) {
        return _ref.apply(this, arguments);
    };
}();
var getAllPaymentOptions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(partnerId, group) {
        var ref, status, data, applicablePaymentOptions, e, ref1, ref2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partnerId, "/payment/options?group_name=").concat(group)
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_0__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        applicablePaymentOptions = data.filter(function(paymentOption) {
                            return paymentOption.applicable;
                        });
                        return [
                            2,
                            {
                                data: applicablePaymentOptions,
                                status: true,
                                statusCode: 200
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: [],
                            status: false,
                            statusCode: status
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                data: [],
                                status: false,
                                statusCode: 401
                            }
                        ];
                    }
                    if ((e === null || e === void 0 ? void 0 : (ref2 = e.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 400) {
                        return [
                            2,
                            {
                                data: [],
                                status: false,
                                errorMessage: e.response.message || "Something went wrong",
                                statusCode: 400
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            data: [],
                            status: false,
                            errorMessage: e.response.message || "Something went wrong",
                            statusCode: 500
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAllPaymentOptions(partnerId, group) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 9985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PaymentOptionType; }
/* harmony export */ });
var PaymentOptionType;
(function(PaymentOptionType) {
    PaymentOptionType["DEALER_PAYMENT"] = "dealer_payment";
    PaymentOptionType["CUSTOMER_PAYMENT"] = "customer_payment";
    PaymentOptionType["DEALER_WALLET_PAYMENT"] = "dealer_wallet_payment";
})(PaymentOptionType || (PaymentOptionType = {}));


/***/ }),

/***/ 7664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);
/* harmony import */ var utils_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7720);
/* harmony import */ var utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1187);



var usePermissionHook = function() {
    var permissions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_context__WEBPACK_IMPORTED_MODULE_1__/* .MPosContext */ .w).permissions;
    var getLobFromPermission = function() {
        if (permissions && (permissions === null || permissions === void 0 ? void 0 : permissions.lob)) {
            return permissions.lob;
        }
        return "";
    };
    var getPartnerIdFromPermission = function() {
        if (permissions) {
            return permissions.partner_id;
        }
        return "";
    };
    var getGroupNameFromPermission = function() {
        if (permissions) {
            return (0,utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getGroup */ .e)(permissions.group, permissions.partner_id);
        }
        return "";
    };
    var getIsSubDealer = function() {
        return getGroupNameFromPermission().toLowerCase() === "sub_dealer";
    };
    return {
        getLobFromPermission: getLobFromPermission,
        getPartnerIdFromPermission: getPartnerIdFromPermission,
        getGroupNameFromPermission: getGroupNameFromPermission,
        getIsSubDealer: getIsSubDealer
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePermissionHook);


/***/ }),

/***/ 1552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nq": function() { return /* binding */ maskedYearStart; },
/* harmony export */   "w8": function() { return /* binding */ REGULAR_DATE_FORMAT; }
/* harmony export */ });
/* unused harmony exports STRING_DATE_FORMAT_COMMA, REGULAR_TIME_FORMAT, currentYear */
var REGULAR_DATE_FORMAT = "MMM d, yyyy"; // Jan 7, 2020
var STRING_DATE_FORMAT_COMMA = "d LLL, yy"; // 24th Oct, 19
var REGULAR_TIME_FORMAT = "h:m a"; // 12:55 PM
var currentYear = new Date().getFullYear();
var maskedYearStart = currentYear - 15;


/***/ }),

/***/ 4679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o0": function() { return /* binding */ formatDateTime; },
  "PZ": function() { return /* binding */ getDD_MM_YYYY; },
  "Se": function() { return /* binding */ getDD_Month_Time; },
  "in": function() { return /* binding */ getHHMM; },
  "a6": function() { return /* binding */ getYYYY_MM_DD; },
  "tj": function() { return /* binding */ snakeToCapitalized; },
  "D1": function() { return /* binding */ toSnakeCase; }
});

// UNUSED EXPORTS: ageCalculation, checkValidDate, checkValidMonth, checkValidYear, getDDMM, getDDMMYYYY, getDateDiff, getDateObject, getMonthName, returnDate

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/toDate/index.js

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters_formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function (pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function (pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function (pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/constants/index.js
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/parseISO/index.js



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
// EXTERNAL MODULE: ./utils/date/constants.ts
var constants = __webpack_require__(1552);
;// CONCATENATED MODULE: ./utils/date/index.ts



var MonthsToDate = {
    1: 31,
    2: 29,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
};
function getMonthName(month) {
    if (month === "01" || month === "1" || month === 1) {
        return "Jan";
    }
    if (month === "02" || month === "2" || month === 2) {
        return "Feb";
    }
    if (month === "03" || month === "3" || month === 3) {
        return "Mar";
    }
    if (month === "04" || month === "4" || month === 4) {
        return "Apr";
    }
    if (month === "05" || month === "5" || month === 5) {
        return "May";
    }
    if (month === "06" || month === "6" || month === 6) {
        return "Jun";
    }
    if (month === "07" || month === "7" || month === 7) {
        return "Jul";
    }
    if (month === "08" || month === "8" || month === 8) {
        return "Aug";
    }
    if (month === "09" || month === "9" || month === 9) {
        return "Sep";
    }
    if (month === "10" || month === 10) {
        return "Oct";
    }
    if (month === "11" || month === 11) {
        return "Nov";
    }
    if (month === "12" || month === 12) {
        return "Dec";
    }
    return "Jan";
}
function getDDMM(dateStr) {
    /* eg. 01 Jan */ if (dateStr === "") {
        return dateStr;
    }
    var date = new Date(dateStr);
    var day = date.getDate();
    var month = getMonthName((date.getMonth() + 1).toString());
    return "".concat(day, " ").concat(month);
}
/** eg. 08:08 AM || 12:39 PM */ function getHHMM(date) {
    try {
        var d = new Date(date);
        var minutes = d.getMinutes() > 9 ? d.getMinutes() : "0".concat(d.getMinutes());
        var ampm = d.getHours() > 12 ? "PM" : d.getHours() === 12 && d.getMinutes() > 0 ? "PM" : "AM";
        var hh = d.getHours() > 12 ? d.getHours() - 12 : d.getHours();
        var h = hh > 9 ? hh : "0".concat(hh);
        return "".concat(h, ":").concat(minutes, " ").concat(ampm);
    } catch (e) {
        return "";
    }
}
function formatDateTime(date) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* REGULAR_DATE_FORMAT */.w8;
    try {
        if (!date) {
            return "";
        }
        try {
            return format(parseISO(date), dateFormat);
        } catch (e) {
            return format(new Date(date), dateFormat);
        }
    } catch (e1) {
        return "Invalid date";
    }
}
function getDDMMYYYY(date) {
    if (date) {
        var day = date.getDate();
        var month = getMonthName((date.getMonth() + 1).toString());
        var year = date.getFullYear();
        return "".concat(day, " ").concat(month, " ").concat(year);
    }
    return "";
}
function getDD_MM_YYYY(date) {
    if (date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var d = day > 9 ? day : "0".concat(day);
        var m = month > 9 ? month : "0".concat(month);
        return "".concat(d, "-").concat(m, "-").concat(year);
    }
    return "";
}
function getYYYY_MM_DD(date) {
    if (date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var d = day > 9 ? day : "0".concat(day);
        var m = month > 9 ? month : "0".concat(month);
        return "".concat(year, "-").concat(m, "-").concat(d);
    }
    return "";
}
function getDD_Month_Time(date) {
    if (date) {
        var day = date.getDate();
        var month = getMonthName((date.getMonth() + 1).toString());
        var time = getHHMM(date.toISOString());
        return "".concat(day, " ").concat(month, ", ").concat(time);
    }
    return "";
}
function ageCalculation(dob) {
    if ((dob === null || dob === void 0 ? void 0 : dob.length) > 0) {
        var split = dob.split("-");
        if (split.length > 0) {
            var year = Number(split[0]);
            var currentYear = new Date().getFullYear();
            return (currentYear - year).toString();
        }
        return "";
    }
    return "";
}
function leapYear(year) {
    return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
}
function checkValidDate(param) {
    var date = param.date, month = param.month, year = param.year;
    if (date === "0") {
        return true;
    }
    if (date === "00") {
        return false;
    }
    if (date > 31) {
        return false;
    }
    if (!month) {
        return true;
    }
    var leapYearCheck = date === 29 && month === 2 && year;
    var parsed = parseInt(month, 10);
    var monthMax = MonthsToDate[parsed];
    if (date <= monthMax) {
        if (leapYearCheck) {
            return leapYear(year);
        }
        return true;
    }
    return false;
}
function checkValidMonth(param) {
    var date = param.date, month = param.month, year = param.year;
    var parsed = parseInt(month, 10);
    if (month === "0") {
        return true;
    }
    if (month === "00") {
        return false;
    }
    if (parsed > 12) {
        return false;
    }
    if (!date) {
        return true;
    }
    var leapYearCheck = date === "29" && month === "02" && year;
    var monthMax = MonthsToDate[parsed];
    if (date <= monthMax) {
        if (leapYearCheck) {
            return leapYear(year);
        }
        return true;
    }
    return false;
}
function checkValidYear(param) {
    var date = param.date, month = param.month, year = param.year;
    if (!date || !month) {
        return true;
    }
    var leapYearCheck = date === "29" && month === "02";
    if (leapYearCheck && year.length > 3) {
        return leapYear(year);
    }
    return true;
}
function returnDate(param) {
    var date = param.date, month = param.month, year = param.year;
    return "".concat(year, "-").concat(month, "-").concat(date);
}
function getDateObject(d) {
    if (!d) {
        return {
            date: "",
            month: "",
            year: ""
        };
    }
    var newDate = new Date(d);
    var month = "".concat(newDate.getMonth() + 1);
    var date = "".concat(newDate.getDate());
    if (month.length < 2) month = "0".concat(month);
    if (date.length < 2) date = "0".concat(date);
    var year = newDate.getFullYear().toString();
    return {
        date: date,
        month: month,
        year: year
    };
}
var getDateDiff = function(date1, date2) {
    try {
        var diffInMs = date1 - date2;
        var diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
        return diffInDays;
    } catch (e) {
        return 0;
    }
};
function snakeToCapitalized(str) {
    return str.split("_") // Split by underscore
    .map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }) // Capitalize each word
    .join(" "); // Join with space
}
function toSnakeCase(str) {
    return str.toLowerCase().split(" ").join("_");
}


/***/ }),

/***/ 1268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ iconTextArrow; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./widgets/cards/iconTextArrow/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    padding: 16px;\n    background: ",
        ";\n    border-radius: 16px;\n    cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    padding: 5px;\n    align-items: center;\n    text-align: center;\n    border-radius: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 5;\n    margin-left: 15px;\n    align-items: center;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    color: #000000;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = dist.styled.div(_templateObject(), function(props) {
    return "linear-gradient(".concat(props.backgroundColor, ")");
});
var IconFlex = dist.styled.div(_templateObject1());
var Icon = dist.styled.div(_templateObject2());
var TextFlex = dist.styled.div(_templateObject3());
var RightArrowFlex = dist.styled.div(_templateObject4());

;// CONCATENATED MODULE: ./widgets/cards/iconTextArrow/index.tsx




function IconTextArrowCard(param) {
    var icon = param.icon, text = param.text, backgroundColor = param.backgroundColor, onClick = param.onClick, iconBackground = param.iconBackground;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        onClick: onClick,
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon, {
                    style: {
                        backgroundColor: iconBackground
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "40px",
                        height: "40px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)(icon)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TextFlex, {
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RightArrowFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "12px",
                    height: "12px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/rightArrow.svg")
                })
            })
        ]
    });
}
/* harmony default export */ var iconTextArrow = (IconTextArrowCard);


/***/ }),

/***/ 89:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tab; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./widgets/tab/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    position: relative;\n    font-size: 16px;\n    line-height: 22px;\n    color: ",
        ";\n\n    &::after {\n        content: '';\n        position: absolute;\n        height: 4px;\n        width: 100%;\n        border-radius: 5px;\n        left: 0px;\n        bottom: -12px;\n        color: #040222;\n        background: ",
        ";\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #d6d9e0;\n    margin-top: 10px;\n    border: 1px solid #d6d9e0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var TabWrapper = dist.styled.div(_templateObject());
var Heading = dist.styled.div(_templateObject1(), function(props) {
    return props.color;
}, function(props) {
    return props.borderColor;
});
var HR = dist.styled.div(_templateObject2());
var OptionDiv = dist.styled.div(_templateObject3(), function(props) {
    return !props.singleTab && "\n    display: flex;\n    flex: 1;\n    justify-content: center;";
});

;// CONCATENATED MODULE: ./widgets/tab/index.tsx


var Tab = function(param) {
    var items = param.items, selectedTab = param.selectedTab, color = param.color, onSelectTab = param.onSelectTab;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TabWrapper, {
                children: items.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionDiv, {
                        singleTab: items.length === 1,
                        onClick: function() {
                            return onSelectTab(item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Heading, {
                            color: selectedTab === item ? "#040222" : "#5B5675",
                            borderColor: selectedTab === item ? color : "",
                            children: item
                        })
                    }, item);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HR, {})
        ]
    });
};
/* harmony default export */ var tab = (Tab);


/***/ }),

/***/ 8533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent',
};
var defaultThreshold = {
    unit: ThresholdUnits.Percent,
    value: 0.8,
};
function parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') {
        return {
            unit: ThresholdUnits.Percent,
            value: scrollThreshold * 100,
        };
    }
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
            return {
                unit: ThresholdUnits.Pixel,
                value: parseFloat(scrollThreshold),
            };
        }
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
            return {
                unit: ThresholdUnits.Percent,
                value: parseFloat(scrollThreshold),
            };
        }
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return defaultThreshold;
}

var InfiniteScroll = /** @class */ (function (_super) {
    __extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function () {
            if (_this.props.scrollableTarget instanceof HTMLElement)
                return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') {
                return document.getElementById(_this.props.scrollableTarget);
            }
            if (_this.props.scrollableTarget === null) {
                console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            }
            return null;
        };
        _this.onStart = function (evt) {
            if (_this.lastScrollTop)
                return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) {
                _this.startY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.startY = evt.touches[0].pageY;
            }
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function (evt) {
            if (!_this.dragging)
                return;
            if (evt instanceof MouseEvent) {
                _this.currentY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.currentY = evt.touches[0].pageY;
            }
            // user is scrolling down to up
            if (_this.currentY < _this.startY)
                return;
            if (_this.currentY - _this.startY >=
                Number(_this.props.pullDownToRefreshThreshold)) {
                _this.setState({
                    pullToRefreshThresholdBreached: true,
                });
            }
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5)
                return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY -
                    _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function () {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false,
                });
            }
            requestAnimationFrame(function () {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function (event) {
            if (typeof _this.props.onScroll === 'function') {
                // Execute this callback in next tick so that it does not affect the
                // functionality of the library.
                setTimeout(function () { return _this.props.onScroll && _this.props.onScroll(event); }, 0);
            }
            var target = _this.props.height || _this._scrollableNode
                ? event.target
                : document.documentElement.scrollTop
                    ? document.documentElement
                    : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered)
                return;
            var atBottom = _this.props.inverse
                ? _this.isElementAtTop(target, _this.props.scrollThreshold)
                : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({ showLoader: true });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength,
        };
        _this.throttledOnScrollListener = throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function () {
        if (typeof this.props.dataLength === 'undefined') {
            throw new Error("mandatory prop \"dataLength\" is missing. The prop is needed" +
                " when loading more content. Check README.md for usage");
        }
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height
            ? this._infScroll
            : this._scrollableNode || window;
        if (this.el) {
            this.el.addEventListener('scroll', this
                .throttledOnScrollListener);
        }
        if (typeof this.props.initialScrollY === 'number' &&
            this.el &&
            this.el instanceof HTMLElement &&
            this.el.scrollHeight > this.props.initialScrollY) {
            this.el.scrollTo(0, this.props.initialScrollY);
        }
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance =
                (this._pullDown &&
                    this._pullDown.firstChild &&
                    this._pullDown.firstChild.getBoundingClientRect()
                        .height) ||
                    0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') {
                throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
            }
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function () {
        if (this.el) {
            this.el.removeEventListener('scroll', this
                .throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function (prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength)
            return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false,
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function (nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) {
            return __assign(__assign({}, prevState), { prevDataLength: nextProps.dataLength });
        }
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop <=
                threshold.value + clientHeight - target.scrollHeight + 1);
        }
        return (target.scrollTop <=
            threshold.value / 100 + clientHeight - target.scrollHeight + 1);
    };
    InfiniteScroll.prototype.isElementAtBottom = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop + clientHeight >= target.scrollHeight - threshold.value);
        }
        return (target.scrollTop + clientHeight >=
            (threshold.value / 100) * target.scrollHeight);
    };
    InfiniteScroll.prototype.render = function () {
        var _this = this;
        var style = __assign({ height: this.props.height || 'auto', overflow: 'auto', WebkitOverflowScrolling: 'touch' }, this.props.style);
        var hasChildren = this.props.hasChildren ||
            !!(this.props.children &&
                this.props.children instanceof Array &&
                this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height
            ? { overflow: 'auto' }
            : {};
        return (react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { style: outerDivStyle, className: "infinite-scroll-component__outerdiv" },
            react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { className: "infinite-scroll-component " + (this.props.className || ''), ref: function (infScroll) { return (_this._infScroll = infScroll); }, style: style },
                this.props.pullDownToRefresh && (react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { style: { position: 'relative' }, ref: function (pullDown) { return (_this._pullDown = pullDown); } },
                    react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { style: {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: -1 * this.maxPullDownDistance,
                        } }, this.state.pullToRefreshThresholdBreached
                        ? this.props.releaseToRefreshContent
                        : this.props.pullDownToRefreshContent))),
                this.props.children,
                !this.state.showLoader &&
                    !hasChildren &&
                    this.props.hasMore &&
                    this.props.loader,
                this.state.showLoader && this.props.hasMore && this.props.loader,
                !this.props.hasMore && this.props.endMessage)));
    };
    return InfiniteScroll;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));

/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);
//# sourceMappingURL=index.es.js.map


/***/ })

}]);